//Task.jsx (Task Add/Update/Delete)

import React, { useEffect, useState } from 'react'
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBullseye, faCheckToSlot, faClock, faCopy, faEarth, faExclamationTriangle, faFileVideo, faHeartPulse, 
  faLightbulb, faListCheck, faLock, faMapLocation, faMicrochip, faMicrophone, faPen, faQrcode, faUpload
  } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import validateManyFields from '../../validations';
import AILightComponent from '../../components/AILightComponent';
import NoSecretsComponent from '../../components/NoSecretsComponent'; 
import SpeechInputComponent from '../../components/SpeechInputComponent';
import TakeSignature from './TakeSignature';
import QRCode from 'react-qr-code';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import { GenerateLCCode } from '../../components/GenerateThink5whysCode';
import { riskMatrix, oppMatrix} from './RiskOppMatrix';
import RiskMatrixTable from './RiskMatrixTable';
import OppMatrixTable from './OppMatrixTable';
import { vaccinationData } from './VaccinationTable';
import VaccinationSchedule from './VaccinationSchedule';
import MOMForm from './MOMForm';
import UploadImage from '../../components/UploadImage';

const Task = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { taskId, ttype } = useParams();
  const mode = taskId === undefined ? "add" : "update";
  const [task, setTask] = useState(null);
  const [userId, setUserId] = useState(authState.user._id);
  const [rcaBookStatus, setRcaBookStatus] = useState(false);

  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [otherUserCode, setOtherUserCode] = useState(authState.user.think5whyscode);
  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showSignatureBox, setShowSignatureBox] = useState(false);
  const [showMapCapture, setShowMapCapture] = useState(false);
  const [showCloneData, setShowCloneData] = useState(false);
  const [showImageUpload, setShowImageUpload] = useState(false);
  const [showVideoUpload, setShowVideoUpload] = useState(false);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [showQRGenrator, setShowQRGenrator] = useState(false);
  const [showDetailForm, setShowDetailForm] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [isHandwritingVisible, setIsHandwritingVisible] = useState(false);

  const [iamtrue, setIamtrue] = useState(false);
  const [isKaizen, setIsKaizen] = useState(false);
  const [isIkigai, setIsIkigai] = useState(false);
  const [isSugo, setIsSugo] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  // const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showAISupportAlert, setShowAISupportAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(null);
  // const [hasEndDate, setHasEndDate] = useState(false);
  // const [hasTime, setHasTime] = useState(false);
  const [startTime, setStartTime] = useState(false);
  const [endTime, setEndTime] = useState(false);
  const [duration, setDuration] = useState('');
  // const [hasEndTime, setHasEndTime] = useState(false);
  const [additionalDataEntry, setAdditionalDataEntry] = useState(false);
  // const [wantToInputAmount, setWantToInputAmount] = useState(false);
  const [isDiary, setIsDiary] = useState(false);
  const [isJournal, setIsJournal] = useState(false);
  const [isHealthCard, setIsHealthCard] = useState(false);
  const [isPetCare, setIsPetCare] = useState(false); 
  const [isFlagged, setIsFlagged] = useState(false);
  const [isSecret, setIsSecret] = useState(false);
  const [showVaccineSchedule, setShowVaccineSchedule] = useState(false);
  const [showMOMForm, setShowMOMForm] = useState(false);

  const [autoTaskCode, setAutoTaskCode] = useState(GenerateLCCode());
  const [calculateRiskScore, setCalculateRiskScore] = useState(false);
  const [calculateOppScore, setCalculateOppScore] = useState(false);
  const [calculatedCO2Score, setCalculatedCO2Score] = useState(0);
  const [showRiskMatrix, setShowRiskMatrix] = useState(false);
  const [showOppMatrix, setShowOppMatrix] = useState(false);
  const [isUpdateLock, setIsUpdateLock] = useState(false);
  const [plainText, setPlainText] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [secretText, setSecretText] = useState('');
  const [encryptedText, setEncryptedText] = useState('');
  const [decryptedText, setDecryptedText] = useState('');
  const noSecret = NoSecretsComponent();

  const isLoggedIn = authState?.isLoggedIn || false;
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const vaccineOptions = vaccinationData.flatMap(item =>
    item.vaccines.map(vaccine => ({
      value: `${item.age} - ${vaccine.name}: ${vaccine.dose}`,
      label: `${item.age} - ${vaccine.name}: ${vaccine.dose}`
    }))
  );

  const [formData, setFormData] = useState({
    user: userId,
    userCode: userCode,
    otherUserCode: otherUserCode,
    purpose: "",
    title: "",
    taskDate: new Date(),
    description: "",
    name: "",
    place: "",
    amount: 0.00,
    currency: "₹",
    qty: 0,
    unit: "",
    category: "",
    subcategory: "",
    tags: "",
    isActive: true,
    isDeleted: false,
    subPurpose: "",
    hasEndDate: false,
    endDate: null,
    hasTime: false,
    startTime: "",
    hasEndTime: false,
    endTime: "",
    isDiary: false,
    diaryType: "",
    isJournal: false,
    journalType: "",
    isHealthCard: false,
    illnessAction: '',
    healthTitle: '',
    healthParticulars: '',
    healthRemarks: '',
    cardHolderCode: '',
    isPetCare: false,
    petName: '',
    isSecret:false,
    secretKey: "",
    remarks: "",
    isFlagged: false,
    currentStatus: "",
    isPublic: false,
    isShared: false,
    pairCode: '',
    teamCode: '',
    rcaCode: '',
    rcaLinkDate: null,
    taskCode: autoTaskCode,
    taskLinkCode: '',  
    projectCode: '',
    processCode: '',
    factoryCode: '',
    isKaizen: false,
    isIkigai: false,
    isSugo: false,
    kaizenCode: '',
    ikigaiCode: '',
    sugoCode: '',
    kaizenCategory: '',
    ikigaiP: '',
    sugoCategory: '',
    targetReduction: 0.1,
    reducedCO2: 0.00,
    iAmTrue: false,
    actualDate: null,
    daysDiff: 0,
    isPair: false,
    isTeam: false,
    isProject: false,
    isProcess: false,
    isLocation: false,
    isLifeChunk: false,
    lifeChunkCode: '',
    isRisk: false,
    isOpportunity: false,
    riskTitle: '',
    riskLikelihood: '',
    riskImpact: '',
    riskScore: 0,
    riskLevel: '',
    riskMitigations: '',
    riskRemarks: '',
    oppTitle: '',
    oppPassionScore: 0,
    oppProfitScore: 0,
    oppScore: 0,
    oppComment: '',
    oppRemarks: '',
    vaccineName: '',
    dateCreated: new Date(),
    createdBy: authState.user._id,
    isFocusTimer: false,
    lrType: '',
    lrAmount: 0.00,
    lrParticulars: '',
    isUpdateLock: true,
    isDeleteLock: true,
    act: '',
    subAct: '',
    actTime: '',
    actDuration: '',
    actSplRemarks: '',
    isToDo: false,
    isDone: false,
    whoseAttendance: '',
    attendeeName: '',
    attendanceStatus: '',
    rightTime: '',
    graceTime: 15,
    timeIn: '',
    timeOut: '',
    inTimeStatus: '',
    outTimeStatus: '',
    subscriptionPeriod: '',
    checklistFor: '',
    mealCycle: '',
    foodGroup: '',
    studyRoutine: '',
    otherRoutine: '',
    routinePeriod: '',
    
    serialNumberByUser: '',
    rating: 1,
    reply: '',
    replyDate: null,
    feedback: '',
    feedbackDate: null,
    status: '',
    statusDate: null,
    statusCommment: '',
    statusHistory: [],

    isGift: false,
    giftAction: '',
    giftItem: '',
    giftPerson: '',
    giftDate: null,
    isReturnGift: false,
    giftAmount: 0.00,

    isEstimate: false,
    isBillBook: false,
    isReceiptBook: false,
    isGSTBook: false,
    hsnCode: '',
    accountJournalType: '',
    customerName: '',
    item: '',
    hsnCode: '',
    rate: 0.00,
    isProcessifyd: false,
    isPreorder: false,
    taskGroupCode: "",
  });
  
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    const config = { 
      url: `/mybooks/think5whysbookbuyingstatus`, 
      method: "post", 
      headers: { Authorization: authState.token },
      data: {userId: userId} 
    };

    fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("response for update",data);
        setRcaBookStatus(true);
    })
    .catch((error) => {
      console.error("Error fetching Think5Whys Main BOK status:", error);
      setError("Error fetching Think5Whys Main BOK status");
    });

  }, [mode, authState, userId, fetchData, setRcaBookStatus]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/tasks/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { taskId: taskId }
      };
  
      // console.log("Getting Data for Update here", config);
      // console.log("Existing formData", formData);
  
      fetchData(config, { showSuccessToast: false })
        .then((data) => {
          // console.log("response for update - ", data.task);
          // console.log("response for data.userrca.taskId", data.task.taskDate);
          setTask(data.task);
          setFormData({
            userCode: data.task.userCode,
            otherUserCode: data.task.otherUserCode,
            purpose: data.task.purpose,
            title: data.task.title,
            taskDate: new Date(data.task.taskDate),
            description: data.task.description,
            name: data.task.name,
            place: data.task.place,
            amount: data.task.amount,
            currency: data.task.currency,
            qty: data.task.qty,
            unit: data.task.unit,
            category: data.task.category,
            subcategory: data.task.subcategory,
            tags: data.task.tags,
            isActive: data.task.isActive,
            isDeleted: data.task.isDeleted,
            subPurpose: data.task.subPurpose,
            hasEndDate: data.task.hasEndDate,
            endDate: data.task.endDate,
            hasTime: data.task.hasTime,
            startTime: data.task.startTime,
            hasEndTime: data.task.hasEndTime,
            endTime: data.task.endTime,
            isDiary: data.task.isDiary,
            diaryType: data.task.diaryType,
            isJournal: data.task.isJournal,
            journalType: data.task.journalType,
            isHealthCard: data.task.isHealthCard,
            illnessAction: data.task.illnessAction,
            healthTitle: data.task.healthTitle,
            healthParticulars: data.task.healthParticulars,
            healthRemarks: data.task.healthRemarks,
            cardHolderCode: data.task.cardHolderCode,
            isPetCare: data.task.isPetCare,
            petName: data.task.petName,
            isSecret: data.task.isSecret,
            secretKey: data.task.secretKey,
            remarks: data.task.remarks,
            isFlagged: data.task.isFlagged,
            currentStatus: data.task.currentStatus,
            isPublic: data.task.isPublic,
            isShared: data.task.isShared,
            pairCode: data.task.pairCode,
            teamCode: data.task.teamCode,
            rcaCode: data.task.rcaCode,
            rcaLinkDate: data.task.rcaLinkDate,
            taskCode: data.task.taskCode,
            taskLinkCode: data.task.taskLinkCode,
            projectCode: data.task.projectCode,
            processCode: data.task.processCode,
            factoryCode: data.task.factoryCode,
            isKaizen: data.task.isKaizen,
            isIkigai: data.task.isIkigai,
            isSugo: data.task.isSugo,
            kaizenCode: data.task.kaizenCode,
            ikigaiCode: data.task.ikigaiCode,
            sugoCode: data.task.sugoCode,
            kaizenCategory: data.task.kaizenCategory,
            ikigaiP: data.task.ikigaiP,
            sugoCategory: data.task.sugoCategory,
            targetReduction: data.task.targetReduction,
            reducedCO2: data.task.reducedCO2,
            iAmTrue: data.task.iAmTrue,
            vaccineName: data.task.vaccineName,
            actualDate: data.task.actualDate,
            daysDiff: data.task.daysDiff,
            isPair: data.task.isPair,
            isTeam: data.task.isTeam,
            isProject: data.task.isProject,
            isProcess: data.task.isProcess,
            isLocation: data.task.isLocation,
            isLifeChunk: data.task.isLifeChunk,
            lifeChunkCode: data.task.lifeChunkCode,
            isRisk: data.task.isRisk,
            isOpportunity: data.task.isOpportunity,
            riskTitle: data.task.riskTitle,
            riskLikelihood: data.task.riskLikelihood,
            riskImpact: data.task.riskImpact,
            riskScore: data.task.riskScore,
            riskLevel: data.task.riskLevel,
            riskMitigations: data.task.riskMitigations,
            riskRemarks: data.task.riskRemarks,
            oppTitle: data.task.oppTitle,
            oppPassionScore: data.task.oppPassionScore,
            oppProfitScore: data.task.oppProfitScore,
            oppScore: data.task.oppScore,
            oppComment: data.task.oppComment,
            oppRemarks: data.task.oppRemarks,
            dateCreated: data.task.dateCreated,
            createdBy: data.task.createdBy,
            isFocusTimer: data.task.isFocusTimer,
            lrType: data.task.lrType,
            lrAmount: data.task.lrAmount,
            lrParticulars: data.task.lrParticulars,
            isUpdateLock: data.task.isUpdateLock,
            isDeleteLock: data.task.isDeleteLock,
            act: data.task.act,
            subAct: data.task.subAct,
            actTime: data.task.actTime,
            actDuration: data.task.actDuration,
            actSplRemarks: data.task.actSplRemarks,
            isToDo: data.task.isToDo,
            isDone: data.task.isDone,
            whoseAttendance: data.task.whoseAttendance,
            attendeeName: data.task.attendeeName,
            attendanceStatus: data.task.attendanceStatus,
            rightTime: data.task.rightTime,
            graceTime: data.task.graceTime,
            timeIn: data.task.timeIn,
            timeOut: data.task.timeOut,
            inTimeStatus: data.task.inTimeStatus,
            outTimeStatus: data.task.outTimeStatus,
            subscriptionPeriod: data.task.subscriptionPeriod,
            checklistFor: data.task.checklistFor,
            mealCycle: data.task.mealCycle,
            foodGroup: data.task.foodGroup,
            studyRoutine: data.task.studyRoutine,
            otherRoutine: data.task.otherRoutine,
            routinePeriod: data.task.routinePeriod,
           
            serialNumberByUser: data.task.serialNumberByUser,
            rating: data.task.rating,
            reply: data.task.reply,
            replyDate: data.task.replyDate,
            feedback: data.task.feedback,
            feedbackDate: data.task.feedbackDate,
            status: data.task.status,
            statusDate: data.task.statusDate,
            statusCommment: data.task.statusCommment,
            statusHistory: data.task.statusHistory,
            isGift: data.task.isGift,
            giftAction: data.task.giftAction,
            giftItem: data.task.giftItem,
            giftPerson: data.task.giftPerson,
            giftDate: data.task.giftDate,
            isReturnGift: data.task.isReturnGift,
            giftAmount: data.task.giftAmount,

            isEstimate: data.task.isEstimate,
            isBillBook: data.task.isBillBook,
            isReceiptBook: data.task.isReceiptBook,
            isGSTBook: data.task.isGSTBook,
            hsnCode: data.task.hsnCode,
            accountJournalType: data.task.accountJournalType,
            customerName: data.task.customerName,
            item: data.task.item,
            hsnCode: data.task.hsnCode,
            rate: data.task.rate,
            isProcessifyd: data.task.isProcessifyd,
            isPreorder: data.task.isPreorder,

            taskGroupCode: data.task.taskGroupCode,
          });
        })
        .catch((error) => {
          console.error("Error fetching LC data:", error);
          setError("Error fetching LC data");
        });
    }
  }, [mode, authState, taskId, fetchData, setTask]);
  
  useEffect(() => {
    if (mode === "add" && ttype) {
      setFormData(prev => ({ ...prev, purpose: ttype }));
    }
  }, [mode, ttype]);

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleStartDateChange = (date) => {
    const isoDate = date ? date.toISOString() : '';
    setStartTime(isoDate);

    // Update formData state
    setFormData(prevFormData => ({
      ...prevFormData,
      startTime: isoDate,
    }));
  };

  const handleEndDateChange = (date) => {
    setStartTime(date ? date.toISOString() : '');
  };

const handleEncrypt = () => {
  const encryptedText = noSecret.handleAesEncrypt(formData.description, formData.secretKey);
  setEncryptedText(encryptedText);
};

const handleDecrypt = () => {
  const decryptedText = noSecret.handleAesDecrypt(encryptedText, formData.secretKey);
  setDecryptedText(decryptedText);
};

const handleShowVaccineSchedule = async () => {
  setShowVaccineSchedule(!showVaccineSchedule);
};

const handleMOM = async () => {
  setShowMOMForm(!showMOMForm);
};

const handleShowRiskMatrix = async () => {
  setShowRiskMatrix(!showRiskMatrix);
};

const handleShowOppMatrix = async () => {
  setShowOppMatrix(!showOppMatrix);
};

const handleCalculateRiskScore = async () => {
  setCalculateRiskScore(true);
  // console.log("formData.riskImpact: ",formData.riskImpact);
  // console.log("formData.riskLikelihood: ",formData.riskLikelihood);
  if (!riskImpact || !riskLikelihood) {
    console.error('Please select both Risk Impact and Risk Likelihood.');
    return;
  }

  const i = parseInt(formData.riskImpact.charAt(0), 10);
  const l = parseInt(formData.riskLikelihood.charAt(0), 10);

  // console.log("Impact number: ", i);
  // console.log("Likelihood number: ", l);
  
  if (isNaN(i) || isNaN(l) || i < 1 || i > 5 || l < 1 || l > 5) {
    console.error('Invalid values for Risk Impact or Risk Likelihood. They must be numbers between 1 and 5.');
    setFormData({ ...formData, riskScore: 0, riskLevel: '', error: 'Invalid values. Risk Impact and Risk Likelihood must be numbers between 1 and 5.' });
    return;
  }

  const riskEntry = riskMatrix.find(
    (entry) => entry.impact === i && entry.likelihood === l
  );

  if (riskEntry) {
    setFormData({ ...formData, riskScore: riskEntry.score, riskLevel: riskEntry.level });
  } else {
    console.error('Risk entry not found for given impact and likelihood');
  }
};

const handleCalculateOppScore = async () => {
  setCalculateOppScore(true);
  const oppPassionScore = formData.oppPassionScore;
  const oppProfitScore = formData.oppProfitScore;
  if (!oppPassionScore || !oppProfitScore) {
    console.error('Please select both Passion Score & Profit Score.');
    setFormData({ ...formData, oppComment: '', error: 'Please select both Passion Score & Profit Score.' });
    return;
  }
  const pas = parseInt(oppPassionScore, 10);
  const pro = parseInt(oppProfitScore, 10);
  if (isNaN(pas) || isNaN(pro) || pas < 1 || pas > 100 || pro < 1 || pro > 100) {
    console.error('Invalid values for Passion Score or Profit Score. They must be numbers between 1 and 100.');
    setFormData({ ...formData, oppComment: 'Passion & Profit values must be from 1 to 100', error: 'Invalid values. Passion & Profit values must be from 1 to 100.' });
    return;
  }
  const isInRange = (value, range) => {
    const [min, max] = range.split('-').map(Number);
    return value >= min && value <= max;
  };
  const oppEntry = oppMatrix.find(
    (entry) => isInRange(pas, entry.passionRange) && isInRange(pro, entry.profitRange)
  );

  if (oppEntry) {
    setFormData({ ...formData, oppComment: oppEntry.comment });
  } else {
    console.error('Opportunity entry not found!');
    setFormData({ ...formData, oppComment: 'Opportunity entry not found for the given Passion Score and Profit Score.', error: 'Opportunity entry not found.' });
  }
};

const handleCalculateCO2Score = async () => {
  setCalculatedCO2Score(0);
}

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    // console.log("selectedPurpose ",formData.purpose)
    const selectedPurpose=formData.purpose;
    let destination='/events-list';

    const navigateBasedOnPurpose = (selectedPurpose) => {
      switch (selectedPurpose) {
        case 'Attendance':
          destination="/attendance-list";
          break;
        case 'Calendar':
          destination="/calendar-list";
          break;          
        case 'Checklist':
          destination="/checklist-list";
          break;
        case 'Cooking':
          destination="/cooking-list";
          break;    
       case 'Digital-Time':
          destination="/digitaltime-list";
          break;       
        case 'Dream':
          destination="/dreams-list";
          break;
        case 'Empathy':
          destination="/empathy-list";
          break;
        case 'Environment':
          destination="/environment-list";
          break;          
        case 'Event':
          destination="/events-list";
          break;
        case 'Experience':
          destination="/experience-list";
          break;
        case 'Events':
          destination="/events-list";
          break;  
        case 'Gym':
          destination="/gym-list";
          break;
        case 'Yoga':
          destination="/yoga-list";
          break;          
        case 'Feeling':
          destination="/feelings-list";
          break;                  
        case 'Food':
          destination="/food-list";
          break;
        case 'Gardening':
          destination="/gardening-list";
          break;  
        case 'Goal':
          destination="/goals-list";
          break;
        case 'Gratitude':
          destination="/gratitude-list";
          break;
        case 'Invitations':
          destination="/invitations-list";
          break;
        case 'Issues':
          destination="/issues-list";
          break;
        case 'Jobless':
          destination="/jobless-list";
          break; 
        case 'Expense':
          destination="/expense-list";
          break;
        case 'Income':
          destination="/income-list";
          break;
        case 'Assets':
          destination="/assets-list";
          break;
        case 'Loans':
          destination="/loans-list";
          break;
        case 'Investments':
          destination="/investments-list";
          break;
        case 'Medicine':
          destination="/medicine-list";
          break;
        case 'Meditation':
          destination="/meditations-list";
          break;          
        case 'Memory':
          destination="/memories-list";
          break;
        case 'Missed-Opportunities':
          destination="/missed-opportunities-list";
          break;
        case 'Monthly-Essentials-Plan':
          destination="/monthly-essentials-plan-list";
          break;          
        case 'Mood':
          destination="/mood-list";
          break;  
        case 'Petty-Account':
          destination="/petty-account-list";
          break;           
        case 'Planner':
          destination="/planner-list";
          break;            
        case 'Play-Sports':
          destination="/play-sports-list";
          break;
        case 'Entertainment':
          destination="/entertainment-list";
          break;          
        case 'Regret':
          destination="/regrets-list";
          break;
        case 'Routine-Diet':
          destination="/routine-diet-list";
          break;
        case 'Routine-Others':
          destination="/routine-others-list";
          break;
        case 'Routine-Study':
          destination="/routine-study-list";
          break;                              
        case 'Salary':
          destination="/salary-list";
          break;
        case 'Study':
          destination="/study-list";
          break;
        case 'Subscription':
          destination="/subscription-list";
          break;          
        case 'Sympathy':
          destination="/sympathy-list";
          break;
        case 'Task':
          destination="/tasks-list";
          break;
        case 'Thoughts':
          destination="/thoughts-list";
          break;   
        case 'ToDo':
          destination="/todo-list";
          break;          
        case 'Training':
          destination="/training-list";
          break;        
        case 'Travel':
          destination="/travels-list";
          break;         
        case 'Vaccination':
          destination="/vaccination-list";
          break;
        case 'Visit':
          destination="/visits-list";
          break;
        case 'Waste':
          destination="/waste-list";
          break;
        case 'Unspecified':
          destination="/unspecified-list";
          break;    

        case 'Crop Observations':
          destination = "/crop-observation-list";
          break;

        case 'Sowing':
          destination = "/sowing-list";
          break;

        case 'Tilling':
          destination = "/tilling-list";
          break;

        case 'Irrigation':
          destination = "/irrigation-list";
          break;

        case 'Weeding':
          destination = "/weeding-list";
          break;

        case 'Fertilizer':
          destination = "/fertilizer-list";
          break;

        case 'Breakfast':
          destination = "/breakfast-list";
          break;

        case 'Pest Control':
          destination = "/pest-control-list";
          break;

        case 'Harvesting':
          destination = "/harvesting-list";
          break;

        case 'Repair':
          destination = "/repair-list";
          break;

        case 'Transporting Fodder':
          destination = "/transporting-fodder-list";
          break;

        case 'Feeding Catle':
          destination = "/feeding-catle-list";
          break;

        case 'Animal Health Check':
          destination = "/animal-health-check-list";
          break;

        case 'Mandi Rate':
          destination = "/mandi-rate-list";
          break;

        case 'Weather Record':
          destination = "/weather-record-list";
          break;          

        case 'Eyewear Record':
          destination = "/eyewear-record-list";
          break;   

        default:
          destination="/tasks-list";
          break;
      }
      return destination;
    };

    if (mode === "add") {
      const config = { 
        url: "/tasks", 
        method: "post",
        data: {formData: formData, user: authState.user._id, startTime: startTime}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        const selectedPurpose = formData.purpose;
        const destination = navigateBasedOnPurpose(selectedPurpose);
        // console.log("destination: "+destination);
        navigate(destination);
      });
    }
    else {
      const config = { 
        url: `/tasks/${taskId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" LC",config);

      fetchData(config).then(() => {
        const selectedPurpose = formData.purpose;
        const destination = navigateBasedOnPurpose(selectedPurpose);
        navigate(destination);
      })
      .catch((error) => {
        console.error("Error updating Task:", error);
        setError("Error updating Task");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.purpose) {
      errors.purpose = "Please select a purpose";
    }
    if (!formData.taskDate) {
      errors.taskDate = "Date is required";
    }
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.description) {
      errors.description = "Description is required";
    } else if (formData.description.length > 1500) {
      errors.description = "Description cannot exceed 1500 characters";
    }
    if(formData.isSugo) {
      if (!formData.targetReduction) {
        errors.targetReduction = "Reduction target is required";
      } else if (isNaN(formData.targetReduction) || Number(formData.targetReduction) <= 0) {
        errors.targetReduction = "Target reduction must be a positive number";
      }
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-blue-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleMicrophoneClick = () => {
    setShowMicrophoneAlert(true);
  };

  const handleDetailFormClick = () => {
    setShowDetailForm(true);
  };

  const handleAddlCheckboxChange = (e) => {
    setAdditionalDataEntry(e.target.checked);
  };

  const handleStartTimeChange = (date) => {
    setStartTime(date);
  };

  const handleEndTimeChange = (date) => {
    setEndTime(date);
  };

  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };

  const handleGenerateEndTime = () => {
    e.preventDefault();
    if (!startTime || !duration) return;

    const durationInMinutes = parseInt(duration, 10);
    if (isNaN(durationInMinutes) || durationInMinutes <= 0) return;

    const endTime = new Date(startTime);
    endTime.setMinutes(startTime.getMinutes() + durationInMinutes);
    setEndTime(endTime);
  };

  const [noEndTime, setNoEndTime] = useState(""); 
  const handleNoEndTimeChange = (e) => {
    setNoEndTime(e.target.checked);
    if (e.target.checked) {
      setEndTime(null);
    }
  };

  const handleOpenHandwriting = () => {
    setIsHandwritingVisible(true);
  };

  const handleCloseSignatureBox = () => {
    setShowSignatureBox(false);
  };

  return (
    <div className="min-h-full bg-black">
        {/* Header */}
              <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
                <div className="flex flex-col">
                  <div className="text-xl lg:text-2xl font-bold text-blue-400">Chronicles / Daily Life</div>
                  <div className="text-[10px] lg:text-lg text-yellow-200">
                    Everyday, Every Moments Matters!
                  </div>
                </div>
        
                {/* Desktop user controls */}
                <div className="hidden md:flex items-center gap-3">
                  {isLoggedIn ? (
                    <>
                      <div className="text-xs text-left text-blue-300">{userName}</div>
                      <button
                        onClick={handleLogout}
                        className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                        title="Logout"
                      >
                        ⏻
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => navigate("/login")}
                        className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                      >
                        Login
                      </button>
                      {/* <button
                        onClick={() => navigate("/signup")}
                        className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
                      >
                        Register
                      </button> */}
                    </>
                  )}
                </div>
        
                {/* Mobile hamburger */}
                <button
                  onClick={() => setIsMobileMenuOpen((s) => !s)}
                  className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
                  aria-label="Toggle menu"
                >
                  {isMobileMenuOpen ? "×" : "☰"}
                </button>
              </header>
        
              {/* Mobile menu content */}
              {isMobileMenuOpen && (
                <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
                  {isLoggedIn ? (
                    <div className="flex flex-row items-center justify-center gap-3">
                      <span className="text-xs text-blue-300 font-medium whitespace-nowrap h-7">
                        {userName}
                      </span>
                      <button
                        onClick={handleLogout}
                        className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                        title="Logout"
                      >
                        ⏻
                      </button>
                    </div>
                  ) : (
                    <div className="flex flex-row items-center justify-center gap-6">
                      <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                        Login
                      </Link>
                      {/* <span className="text-blue-500">|</span>
                      <Link to="/signup" className="text-blue-300 hover:text-yellow-300">
                        Register
                      </Link> */}
                    </div>
                  )}
                </div>
              )}
        {/* <h2 className='text-2xl font-bold text-white text-center mb-2'>Chronicles</h2> */}
            {loading ? (
              <Loader />
            ) : (
            <div className='text-sm'>
              <div className='flex justify-center'>
                <h2 className="mt-4 text-xl text-yellow-200">{mode === "add" ? "Add New Chronicle" : "Edit Chronicle"}</h2>
              </div>
              <div className="border-container text-m ">
                <p className="text-yellow-200 text-sm mt-2 mb-2">Think5Whys Main BOK Status: {rcaBookStatus ? "Purchased": "Not Purchased Yet"}</p>
                  <div className="p-2 bg-white shadow-md rounded-lg mb-4 flex flex-row justify-between">
                    <p className="text-gray-700 text-m font-semibold">Your Visible Life Chronicle (LC) Code: {autoTaskCode}</p>
                    <QRCode value={autoTaskCode} size={64} className="ml-4" />
                  </div>
                  <div className="p-2 bg-white shadow-md rounded-lg mb-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          className="mr-2 cursor-pointer"
                          checked={showControls} 
                          onChange={() => setShowControls(!showControls)} 
                        />
                        <span className="text-m font-semibold text-gray-700">Show More Controls</span>
                        <FontAwesomeIcon icon={faCheckToSlot} className="text-yellow-500 text-2xl ml-3" />
                      </div>
                    </div>                  
                  </div>
                {showControls && (
                  <div className="p-2 bg-white shadow-md rounded-lg">
                    <div className="grid grid-cols-1 md:grid-cols-2">
                      {/* Detail Entry &  It is Secret*/}
                      <div className="flex flex-row justify-between items-center cursor-pointer">
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={showDetailForm} 
                            onChange={() => setShowDetailForm(!showDetailForm)} 
                          />
                          <span className="text-lg font-medium text-gray-600">Detail Entry</span>
                          <FontAwesomeIcon icon={faListCheck} className="text-yellow-500 text-xl ml-3" />
                      </div>
                      <div className='w-6/12'>
                        <input 
                          type="checkbox" 
                          className="mr-2 cursor-pointer"
                          checked={formData.isSecret} 
                          onChange={(e) => setFormData({ ...formData, isSecret: e.target.checked })} 
                        />
                        <span className="text-lg font-medium text-gray-600">It is Secret</span>
                        <FontAwesomeIcon icon={faLock} className="text-yellow-500 text-xl ml-3" />
                      </div>
                    </div>

                      {/* Kaizen & Ikigai*/}
                      <div className="flex flex-row justify-between items-center cursor-pointer">
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={formData.isKaizen} 
                            onChange={(e) => setFormData({ ...formData, isKaizen: e.target.checked })} 
                          />
                          <span className="text-lg font-medium text-gray-600">Kaizen</span>
                          <FontAwesomeIcon icon={faBullseye} className="text-blue-500 text-xl ml-3" />
                        </div>
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={formData.isIkigai} 
                            onChange={(e) => setFormData({ ...formData, isIkigai: e.target.checked })} 
                          />
                          <span className="text-lg font-medium text-gray-600">Ikigai</span>
                          <FontAwesomeIcon icon={faHeartPulse} className="text-blue-400 text-xl ml-3" />
                        </div>
                      </div>

                      {/* SUGO & Focus Timer*/}
                      <div className="flex flex-row justify-between items-center cursor-pointer">
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={formData.isSugo} 
                            onChange={(e) => setFormData({ ...formData, isSugo: e.target.checked })} 
                          />
                          <span className="text-lg font-medium text-gray-600">SUGO</span>
                          <FontAwesomeIcon icon={faEarth} className="text-green-500 text-xl ml-3" />
                        </div>
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={formData.isFocusTimer} 
                            onChange={(e) => setFormData({ ...formData, isFocusTimer: e.target.checked })} 
                          />
                          <span className="text-lg font-medium text-gray-600">Add to Focus Timer</span>
                          <FontAwesomeIcon icon={faClock} className="text-orange-500 text-xl ml-3" />
                        </div>
                      </div>

                      {/* Risk & Opportunity */}
                      <div className="flex flex-row justify-between items-center cursor-pointer">
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={formData.isRisk} 
                            onChange={(e) => setFormData({ ...formData, isRisk: e.target.checked })} 
                          />
                          <span className="text-lg font-medium text-gray-600">Risk</span>
                          <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-500 text-xl ml-3" />
                        </div>
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={formData.isOpportunity} 
                            onChange={(e) => setFormData({ ...formData, isOpportunity: e.target.checked })} 
                          />
                          <span className="text-lg font-medium text-gray-600">Opportunity</span>
                          <FontAwesomeIcon icon={faLightbulb} className="text-yellow-500 text-xl ml-3" />
                        </div>
                      </div>

                      {/* AI Support &  Voice Input*/}
                      <div className="flex flex-row justify-between items-center cursor-pointer">
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={isCheckedAISupport} 
                            onChange={() => setIsCheckedAISupport(!isCheckedAISupport)} 
                          />
                          <span className="text-lg font-medium text-gray-600">Gen AI Support</span>
                          <FontAwesomeIcon icon={faMicrochip} className="text-yellow-500 text-xl ml-3" />
                        </div>
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={showMicrophoneAlert} 
                            onChange={() => setShowMicrophoneAlert(!showMicrophoneAlert)} 
                          />
                          <span className="text-lg font-medium text-gray-600">Enable Voice Input</span>
                          <FontAwesomeIcon icon={faMicrophone} className="text-yellow-500 text-xl ml-3" />
                        </div>
                      </div>

                      {/* Signature */}
                      <div className="flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          className="mr-2 cursor-pointer"
                          checked={showSignatureBox} 
                          onChange={() => setShowSignatureBox(!showSignatureBox)} 
                        />
                        <span className="text-lg font-medium text-gray-600">Enable Signature</span>
                        <FontAwesomeIcon icon={faPen} className="text-yellow-500 text-xl ml-3" />
                      </div>

                      {/* Location Capture */}
                      <div className="flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          className="mr-2 cursor-pointer"
                          checked={showMapCapture} 
                          onChange={() => setShowMapCapture(!showMapCapture)} 
                        />
                        <span className="text-lg font-medium text-gray-600">Location Capture</span>
                        <FontAwesomeIcon icon={faMapLocation} className="text-yellow-500 text-xl ml-3" />
                      </div>

                      {/* Clone Chronicle Data */}
                      <div className="flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          className="mr-2 cursor-pointer"
                          checked={showCloneData} 
                          onChange={() => setShowCloneData(!showCloneData)} 
                        />
                        <span className="text-lg font-medium text-gray-600">Clone Chronicle Data</span>
                        <FontAwesomeIcon icon={faCopy} className="text-yellow-500 text-xl ml-3" />
                      </div>

                      {/* Image Upload & Video Upload*/}
                      <div className="flex flex-row justify-between items-center cursor-pointer">
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={showImageUpload} 
                            onChange={() => setShowImageUpload(!showImageUpload)} 
                          />
                          <span className="text-lg font-medium text-gray-600">Image Upload</span>
                          <FontAwesomeIcon icon={faUpload} className="text-yellow-500 text-xl ml-3" />
                        </div>
                        <div className='w-6/12'>
                          <input 
                            type="checkbox" 
                            className="mr-2 cursor-pointer"
                            checked={showVideoUpload} 
                            onChange={() => setShowVideoUpload(!showVideoUpload)} 
                          />
                          <span className="text-lg font-medium text-gray-600">Video Upload</span>
                          <FontAwesomeIcon icon={faFileVideo} className="text-yellow-500 text-xl ml-3" />
                        </div>
                      </div>

                      {/* QR Scanner */}
                      <div className="flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          className="mr-2 cursor-pointer"
                          checked={showQRScanner} 
                          onChange={() => setShowQRScanner(!showQRScanner)} 
                        />
                        <span className="text-lg font-medium text-gray-600">Enable QR Scanner</span>
                        <FontAwesomeIcon icon={faQrcode} className="text-yellow-500 text-xl ml-3" />
                      </div>
                    </div>
                  </div>
                )}
                {showSignatureBox && (
                  <div className="border-container-gray ml-8 mt-4">  
                      <TakeSignature onClose={handleCloseSignatureBox} />
                  </div> 
                )}

                {showCloneData && (
                  <div className="border-container-gray ml-8 mt-4">  
                      
                  </div> 
                )}

              </div>
              <div className="border-container-gray ml-8">
                {/* <div className="mb-2 text-sm">
                  <label htmlFor="purpose">Purpose*:</label>
                  <br />
                  <select name="purpose" id="purpose" value={formData.purpose}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                    <option value="">Select a purpose</option>

                    <optgroup label="Business & Commerce">
                      <option value="Manufactoring">Manufacturing</option>
                      <option value="Retail Sales">Retail Sales</option>
                      <option value="Marketing">Marketing</option>
                    </optgroup>

                    <optgroup label="Education & Learning">
                      <option value="Study">Study</option>
                      <option value="Teaching">Teaching</option>
                      <option value="RnD">RnD</option>
                    </optgroup>

                    <optgroup label="Environmental & Community">
                      <option value="Environment">Environmental Activity</option>
                      <option value="LifeResources">Life Resources</option>
                    </optgroup>

                    <optgroup label="Events & Travel">
                      <option value="Event">Event</option>
                      <option value="Travel">Travel</option>
                      <option value="Visit">Visit</option>
                    </optgroup>
                    
                    <optgroup label="Food & Nutrition">
                      <option value="Food">Food</option>
                      <option value="Routine Diet">Routine - Diet</option>
                    </optgroup>

                    <optgroup label="Health & Medical">
                      <option value="Exercise">Gym-Yoga-Exercise</option>
                      <option value="Medicine">Medicine</option>
                      <option value="Treatment">Treatment</option>
                      <option value="Vaccination">Vaccination</option>
                    </optgroup>

                    <optgroup label="Household & Daily Life">
                      <option value="Budget">Budget</option>
                      <option value="Checklist">Checklist</option>
                      <option value="Cooking">Cooking</option>
                      <option value="Grocery">Grocery</option>
                      <option value="Monthly Essentials Plan">Monthly Essentials Plan</option>
                      <option value="Purchase">Purchase</option>
                      <option value="Waste">Waste</option>
                    </optgroup>

                    <optgroup label="Leisure & Hobbies">
                      <option value="Gardening">Gardening</option>
                      <option value="Hobby">Hobby</option>
                      <option value="Play">Play-Entertainment</option>
                    </optgroup>

                    <optgroup label="Personal Wellness & Development">
                      <option value="Bread & Butter">Bread & Butter</option>
                      <option value="Caretaking">Caretaking</option>
                      <option value="Dream">Dream</option>
                      <option value="Empathy">Empathy</option>
                      <option value="Feeling">Feeling</option>
                      <option value="Gratitude">Gratitude</option>
                      <option value="Illness">Illness / Sickness</option>
                      <option value="Meditation">Meditation</option>
                      <option value="Memory">Memory</option>
                      <option value="Mood">Mood</option>
                      <option value="Physical Growth">Physical Growth</option>
                      <option value="Regret">Regret</option>
                      <option value="Routine Diet">Routine - Diet</option>
                      <option value="Routine Study">Routine - Study</option>
                      <option value="Routine Others">Routine - Others</option>
                      <option value="Sympathy">Sympathy</option>
                      <option value="Thought">Thought</option>
                    </optgroup>

                    <optgroup label="Relationships & Social Activities">
                      <option value="Gift">Gift</option>
                      <option value="Invitation">Invitation</option>
                      <option value="Social Activity">Social Activity</option>
                      <option value="Sympathy">Sympathy</option>
                      <option value="Voulenteering">Voulenteering</option>
                    </optgroup>

                    <optgroup label="Technology & Innovation">
                      <option value="IT">IT</option>
                      <option value="RnD">RnD</option>
                    </optgroup>

                    <optgroup label="Work & Professional">
                      <option value="Accounting & Finance">Accounting & Finance</option>
                      <option value="Admin">Admin</option>
                      <option value="Attendance">Attendance</option>
                      <option value="Candidate Search">Candidate Search</option>
                      <option value="Consulting">Consulting</option>
                      <option value="Customer Service">Customer Service</option>
                      <option value="HR">HR</option>
                      <option value="Investigation">Investigation</option>
                      <option value="IT">IT</option>
                      <option value="Job Search">Job Search</option>
                      <option value="Job Work">Job Work</option>
                      <option value="Accounting Journal">Journal - Accounting</option>
                      <option value="Marketing">Marketing</option>
                      <option value="Meeting">Meeting</option>
                      <option value="Operations">Operations</option>
                      <option value="Onsite Work">Onsite Work</option>
                      <option value="Salary">Salary</option>
                      <option value="Sales">Sales</option>
                      <option value="Service">Service</option>
                    </optgroup>

                    <optgroup label="Other Specific Purposes">
                      <option value="Jobless">EMI</option>
                      <option value="KOT">KOT</option>
                      <option value="Pet">Pet</option>
                      <option value="Subscription">Subscription</option>
                      <option value="Task">Task</option>
                      <option value="Training">Training</option>
                      <option value="Jobless">Jobless</option>
                      <option value="Unspecified">Unspecified Purpose</option>
                    </optgroup>
                  </select>

                  {fieldError("purpose")}
                </div> */}
                <div className="mb-2 text-sm">
                  <label htmlFor="purpose">Purpose*:</label>
                  <br />

                  <select
                    name="purpose"
                    id="purpose"
                    value={
                      ttype
                        ? ttype // auto-select when ttype defined
                        : formData.purpose || ""
                    }
                    onChange={handleChange}
                    // disabled={mode === "add" && ttype} 
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      height: "36px",
                      minHeight: "40px",
                    }}
                  >
                    {/* Show “Select a purpose” only if ttype is NOT defined */}
                    {!ttype && <option value="">Select a purpose</option>}

                    {[
                      {
                        label: "Business & Commerce",
                        options: ["Manufacturing", "Retail-Sales", "Marketing", "Petty-Account"],
                      },
                      {
                        label: "Education & Learning",
                        options: ["Study", "Teaching", "RnD"],
                      },
                      {
                        label: "Environmental & Community",
                        options: ["Environment"],
                      },
                      {
                        label: "Events & Travel",
                        options: ["Events", "Travel", "Visit"],
                      },
                     {
                        label: "Farmers",
                        options: [
                          "Animal Health Check",
                          "Breakfast",
                          "Crop Observations",
                          "Feeding Catle",
                          "Fertilizer",
                          "Harvesting",
                          "Irrigation",
                          "Mandi Rate",
                          "Other Tasks",
                          "Pest Control",
                          "Repair",
                          "Sowing",
                          "Tilling",
                          "Transporting Fodder",
                          "Weather Record",
                          "Weeding"
                        ],
                      },
                      {
                        label: "Food & Nutrition",
                        options: ["Food", "Routine-Diet"],
                      },
                      {
                        label: "Health & Medical",
                        options: ["Exercise", "Gym", "Yoga", "Medicine", "Treatment", "Vaccination"],
                      },
                      {
                        label: "Household & Daily Life",
                        options: [
                          "Assets",
                          "Budget",
                          "Checklist",
                          "Cooking",
                          "Expense",
                          "Eyewear",
                          "Grocery",
                          "Income",
                          "Investments",
                          "Loans",                                        
                          "Monthly-Essentials-Plan",
                          "Planner",
                          "Purchase",
                          "ToDo",
                          "Waste",
                        ],
                      },
                      {
                        label: "Leisure & Hobbies",
                        options: ["Gardening", "Hobby", "Play-Sports", "Entertainment"],
                      },
                      {
                        label: "Personal Wellness & Development",
                        options: [
                          "Bread-Butter",
                          "Caretaking",
                          "Digital-Time",
                          "Dream",
                          "Empathy",
                          "Eyewear",
                          "Feeling",
                          "Gratitude",
                          "Illness",
                          "Meditation",
                          "Memory",
                          "Mood",
                          "Physical-Growth",
                          "Regret",
                          "Routine-Diet",
                          "Routine-Study",
                          "Routine-Others",
                          "Sympathy",
                          "Thoughts",
                        ],
                      },
                      {
                        label: "Relationships & Social Activities",
                        options: [
                          "Gift",
                          "Invitations",
                          "Social-Activity",
                          "Sympathy",
                          "Voulenteering",
                        ],
                      },
                      {
                        label: "Technology & Innovation",
                        options: ["IT", "RnD"],
                      },
                      {
                        label: "Work & Professional",
                        options: [
                          "Accounting-Finance",
                          "Admin",
                          "Attendance",
                          "Calendar",
                          "Candidate-Search",
                          "Consulting",
                          "Customer-Service",
                          "Experience",
                          "Goal",
                          "HR",
                          "Issues",
                          "Investigation",
                          "IT",
                          "Job-Search",
                          "Job-Work",
                          "Accounting-Journal",
                          "Marketing",
                          "Meeting",
                          "Missed-Opportunities",
                          "Operations",
                          "Onsite-Work",
                          "Salary",
                          "Sales",
                          "Service",
                        ],
                      },
                      {
                        label: "Other Specific Purposes",
                        options: [
                          "EMI",
                          "KOT",
                          "Pet",
                          "Subscription",
                          "Tasks",
                          "Training",
                          "Jobless",
                          "Unspecified",
                        ],
                      },
                    ].map((group) => (
                      <optgroup key={group.label} label={group.label}>
                        {group.options.map((opt) => {
                          const showOption =
                            !ttype || opt.toLowerCase() === ttype.toLowerCase();

                          return (
                            <option
                              key={opt}
                              value={opt}
                              hidden={!showOption && mode === "add"}
                            >
                              {opt}
                            </option>
                          );
                        })}
                      </optgroup>
                    ))}
                  </select>

                  {fieldError("purpose")}
                </div>


                {formData.purpose==='Attendance' && (
                  <div className="mb-2 text-sm">
                    <label htmlFor="whoseAttendance">Whose Attendance:</label>
                    <br />
                    <select name="whoseAttendance" id="whoseAttendance" value={formData.whoseAttendance}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                      <option value="">Select Persona</option>
                      <option value="CarWasher">Car Washer</option>
                      <option value="Caretaker">Caretaker</option>
                      <option value="Cook">Cook</option>
                      <option value="Driver">Driver</option>
                      <option value="Gardener">Gardener</option>
                      <option value="HouseKeeper">Housekeeper</option>
                      <option value="Maid">Maid</option>
                      <option value="Self">Self</option>
                      <option value="Staff">Staff</option>
                      <option value="Tutor">Tutor</option>
                      <option value="Others">Others</option>
                    </select>
                    {fieldError("whoseAttendance")}
                  </div>
                )}
                {formData.purpose==='Checklist' && (
                  <div className="mb-2 text-sm">
                    <label htmlFor="checklistFor">Checklist For:</label>
                    <br />
                    <select name="checklistFor" id="checklistFor" value={formData.checklistFor}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                        <option value="bod">Beginning of Day (BOD) Checklist</option>
                        <option value="budgeting">Budgeting Checklist</option>
                        <option value="car-maintenance">Car Maintenance Checklist</option>
                        <option value="child-care">Child Care Checklist</option>
                        <option value="cleaning">Cleaning Checklist</option>
                        <option value="daily-routine">Daily Routine Checklist</option>
                        <option value="eod">End of Day (EOD) Checklist</option>
                        <option value="event-planning">Event Planning Checklist</option>
                        <option value="exercise">Exercise Checklist</option>
                        <option value="frequent-travel">Frequent Travel Checklist</option>
                        <option value="gardening">Gardening Checklist</option>
                        <option value="grocery-shopping">Grocery Shopping Checklist</option>
                        <option value="home-check">Home Check Checklist</option>
                        <option value="home-chore">Home Chore Checklist</option>
                        <option value="holiday-preparation">Holiday Preparation Checklist</option>
                        <option value="hygiene">Hygiene Checklist</option>
                        <option value="meeting-preparation">Meeting Preparation Checklist</option>
                        <option value="moving-house">Moving House Checklist</option>
                        <option value="personal-chore">Personal Chore Checklist</option>
                        <option value="pet-care">Pet Care Checklist</option>
                        <option value="project-planning">Project Planning Checklist</option>
                        <option value="safety">Safety Checklist</option>
                        <option value="self-discipline">Self Discipline Checklist</option>
                        <option value="study">Study Checklist</option>
                        <option value="treatment">Treatment Checklist</option>
                    </select>
                    {fieldError("checklistFor")}
                  </div>
                )}
                {formData.purpose==='Gift' && (
                  <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label htmlFor="giftAction">Gift Action:</label>
                    <br />
                    <select name="giftAction" id="giftAction" value={formData.giftAction}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                      <option value="">- Select One -</option>
                      <option value="I Gifted">I Gifted</option>
                      <option value="I Receiced">I Received</option>
                      <option value="I am Planning">I am Planning</option>
                      <option value="I Wish">I Wish</option>
                    </select>
                    {fieldError("giftAction")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isReturnGift} onChange={(e) => setFormData({ ...formData, isReturnGift: e.target.checked })} />
                      This is Return Gift
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="giftItem">Item:</label>
                    <br />
                    <input 
                      type="text" 
                      name="giftItem" 
                      id="giftItem" 
                      value={formData.giftItem} 
                      placeholder="Item Name..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("giftItem")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="giftPerson">Person:</label>
                    <br />
                    <input 
                      type="text" 
                      name="giftPerson" 
                      id="giftPerson" 
                      value={formData.giftPerson} 
                      placeholder="Person..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("giftPerson")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="giftAmount">Value: </label>
                    <br />
                    <input 
                      type="number" 
                      name="giftAmount" 
                      id="giftAmount" 
                      value={formData.giftAmount} 
                      placeholder="0.00"
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '150px',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("giftAmount")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="giftDate">Date*:</label>
                    <br />
                    <DatePicker
                      selected={formData.giftDate}
                      onChange={date => setFormData({ ...formData, giftDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="giftDate"
                      name="giftDate"
                      className="form-control h-8"
                    />
                    {fieldError("giftDate")}
                  </div>

                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isGift} onChange={(e) => setFormData({ ...formData, isGift: e.target.checked })} />
                      Save to Gift Diary
                    </label>
                  </div>
                  </div>
                )}
                {formData.purpose==='Illness' && (
                  <div className="border-container">
                    <div className="mb-2 text-sm">
                      <label htmlFor="illnessAction">Illness / Sickness Action:</label>
                      <br />
                      <select name="illnessAction" id="illnessAction" value={formData.illnessAction}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                        <option value="">- Select Stage-</option>
                        <option value="Self Complaint">My Complaint</option>
                        <option value="Self Medication">Self Medication</option>
                        <option value="Personal Information">Personal Information</option>
                        <option value="Insurance Information">Insurance Information</option>
                        <option value="Emergency Instructions">Emergency Instructions</option>
                        <option value="Allergies">Allergies</option>
                        <option value="Chronic Conditions">Chronic Conditions</option>
                        <option value="Current Medications">Current Medications</option>
                        <option value="Healtcare Provider Details">Healtcare Provider Details</option>
                        <option value="Additional Health Notes">Additional Health Notes</option>
                        <option value="Consultation">Consultation</option>
                        <option value="Measurements">Measurements</option>
                        <option value="Presenting Complaint">Presenting Complaint</option>
                        <option value="Primary Diagnosis">Primary Diagnosis</option>
                        <option value="Further Advice">Further Advice</option>
                        <option value="Medicine Prescribed">Medicine Prescribed</option>
                        <option value="Non-Medical Suggestions">Non-Medicinal Suggestions</option>
                        <option value="Suggested Investigation">Suggested Investigation</option>
                        <option value="Lab Report">Lab Report</option>
                        <option value="Second Opinion">Second Opinion</option>
                        <option value="Alternate Medicine">Alternate Medicine</option>
                        <option value="OPD Follow-up">OPD Follow-up</option>
                        <option value="IPD Visits">IPD Visits</option>
                        <option value="IPD Case Paper">IPD Case Paper</option>
                        <option value="Surgery Consent">Surgery Consent</option>
                        <option value="Discharge Summary">Discharge Summary</option>
                        <option value="Medical Certificate">Medical Certificate</option>
                      </select>
                      {fieldError("illnessAction")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="healthTitle">Particulars/Name/Title:</label>
                      <br />
                      <input 
                        type="text" 
                        name="healthTitle" 
                        id="healthTitle" 
                        value={formData.healthTitle} 
                        placeholder="Particulars..."
                        maxLength="100"
                        onChange={handleChange}
                        className='bg-white text-black'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("healthTitle")}
                    </div>
                    <div className="text-sm">
                      <label htmlFor="giftItem">Description:</label>
                      <br />
                      <textarea 
                        type="text" 
                        name="healthParticulars" 
                        id="healthParticulars" 
                        value={formData.healthParticulars} 
                        placeholder="Description..."
                        onChange={handleChange}
                        className='bg-white text-black'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          height: '250px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("healthParticulars")}
                    </div>
                    <div className="text-sm">
                      <label htmlFor="healthRemarks">Additional Remarks:</label>
                      <br />
                      <textarea 
                        type="text" 
                        name="healthRemarks" 
                        id="healthRemarks" 
                        value={formData.healthRemarks} 
                        placeholder="Additional Remarks..."
                        onChange={handleChange}
                        className='bg-white text-black'
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '100%',
                          height: '250px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("healthRemarks")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="healthRemarks">Upload File (Doc/PDF/Image/Video):</label>
                      <UploadImage />
                    </div>
                  </div>
                )}
                {formData.purpose==='Accounting Journal' && (
                  <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label htmlFor="accountJournalType">Journal Type:</label>
                    <br />
                    <select name="accountJournalType" id="accountJournalType" value={formData.accountJournalType}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                      <option value="">Select Entry Type</option>
                      <option value="Opening">Opening</option>
                      <option value="Adjusting">Adjusting</option>
                      <option value="Transfer">Transfer</option>
                      <option value="Reversing">Reversing</option>
                      <option value="Compound">Compound</option>
                      <option value="Closing">Closing</option>
                      <option value="Unknown">Unknown</option>
                    </select>
                    {fieldError("accountJournalType")}
                  </div>
                </div>
                )}
                {formData.purpose==='Meeting' && (
                    <div className="border-container">
                    <div className="mb-2 text-sm">
                      <button
                          className='bg-purple-700 mt-2'
                          onClick={handleMOM}
                          style={{ maxWidth: '300px', height: '44px'}}
                        >
                          Fill Detailed MOM Form
                      </button>
                      { showMOMForm && (
                        <div className="mb-2 text-blue-700">
                            <MOMForm />
                        </div>
                      )}
                    </div>
                    </div>
                )}
                {formData.purpose==='LifeResources' && (
                    <div className="border-container">
                    <div className="mb-2 text-sm">
                      <label htmlFor="lrType">Type:</label>
                      <br />
                      <select name="lrType" id="lrType" value={formData.lrType}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                        <option value="">Select type</option>
                        <option value="Income">Income</option>
                        <option value="Expense">Expense</option>
                        <option value="Assets">Assets</option>
                        <option value="Investment">Investment</option>
                        <option value="LoanGiven">LoanGiven</option>
                        <option value="LoanTaken">LoanTaken</option>
                      </select>
                      {fieldError("lrType")}
                    </div>
                    </div>
                )}
                {formData.purpose==='Routine Diet' && (
                  <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label htmlFor="mealCycle">Meal Cycle:</label>
                    <br />
                    <select name="mealCycle" id="mealCycle" value={formData.mealCycle}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                      <option value="">Select Meal Cycle / Diet Routine</option>
                      <option value="Pre-Breakfast">Pre-Breakfast - 8.30 AM</option>
                      <option value="Breakfast">Breakfast - 9.00 AM</option>
                      <option value="Pre-Lunch">Pre-Lunch - 12.00 PM</option>
                      <option value="Lunch">Lunch - 1.00 PM</option>
                      <option value="Snacks">Snacks - 4.00 PM</option>
                      <option value="Dinner">Dinner - 8.00 PM</option>
                      <option value="Random">Random - Anytime Munch</option>
                    </select>
                    {fieldError("mealCycle")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="foodGroup">Food Group:</label>
                    <br />
                    <select name="foodGroup" id="foodGroup" value={formData.foodGroup}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                      <option value="">Select Food Group</option>
                      <option value="Fruits">Fruits - Essential</option>
                      <option value="Lentils-Pulses-Legumes">Lentils / Pulses /Legumes - Essential</option>
                      <option value="Nuts and Seeds">Nuts & Seeds - Essential</option>
                      <option value="Vegetables">Vegetables - Essential</option>
                      <option value="Whole Grain">Whole Grain - Essential</option>
                      <option value="Eggs">Eggs - Choice</option>
                      <option value="Meat">Meat - Choice</option>
                      <option value="Milk">Milk - Choice</option>
                      <option value="Junk Food">Junk - Avoidable</option>
                      <option value="Stale Food">Stale - Avoidable</option>
                    </select>
                    {fieldError("mealCycle")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="routinePeriod">Routine Period:</label>
                    <br />
                    <input 
                      type="text" 
                      name="routinePeriod" 
                      id="routinePeriod" 
                      value={formData.routinePeriod} 
                      placeholder="Enter period..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '50%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("routinePeriod")}
                  </div>
                </div>
                )}
                 {formData.purpose==='Sales' && (
                  <div className="border-container">
                    <div className="ml-2 mr-2 mb-2 text-sm flex flex-col">
                      <label className="ml-2" htmlFor="customerName">Customer Name: </label>
                      <br />
                      <input type="text" name="customerName" id="customerName" value={formData.customerName} placeholder="Customer Name"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                    </div>
                    <div className="ml-2 mr-2 mb-2 text-sm">
                      <label htmlFor="taskdate">Bill Date*:</label>
                      <br />
                      <DatePicker
                        selected={formData.taskDate}
                        onChange={date => setFormData({ ...formData, taskDate: date })}
                        dateFormat="dd/MM/yyyy"
                        id="taskdate"
                        name="taskdate"
                        className="form-control h-8"
                      />
                      {fieldError("taskdate")}
                   </div>
                   <div className="ml-2 mr-2 mb-2 text-sm flex flex-col">
                    <label htmlFor="item">Item Name: </label>
                    <input type="text" name="item" id="item" value={formData.item} placeholder="Item Name.."
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                    <label className="ml-4" htmlFor="hsnCode">HSN Code: </label>
                    <br />
                    <input type="text" name="hsnCode" id="hsnCode" value={formData.hsnCode} placeholder="HSN Code"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} />
                    <label className="ml-4" htmlFor="hsnCode">GST Rate: </label>  
                    <input type="number" name="gstRate" id="gstRate" value={formData.gstRate} placeholder="GST Rate.."
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                  </div>
                   <div className="ml-2 mr-2 mb-2 text-sm flex flex-col">
                    <label htmlFor="qty">Qty: </label>
                    <br />
                    <input type="text" name="qty" id="qty" value={formData.qty} placeholder="Qty"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '80px' }} />
                    <label htmlFor="">Unit: </label>
                    <br />
                    <input type="text" name="unit" id="unit" value={formData.unit} placeholder="Unit"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                  </div>
                  <div className="ml-2 mr-2 mb-2 text-sm flex flex-col">
                    <label htmlFor="rate">Rate: </label>
                    <br />
                    <input type="number" name="rate" id="rate" value={formData.rate} placeholder="Rate"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                    <label htmlFor="amount">Amount: </label>
                    <br />
                    <input type="text" name="amount" id="amount" value={formData.amount} placeholder="Amount"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                    <label htmlFor="currency">Currency: </label>
                    <br />
                    <input type="text" name="currency" id="currency" value={formData.currency} placeholder="₹"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '75px' }} />
                  </div>
                  <div className="ml-2 mr-2 mb-2 text-sm">
                    <label htmlFor="remarks">Special Remarks: </label>
                    <br />
                    <input type="text" name="remarks" id="remarks" value={formData.remarks} placeholder="Remarks"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '75%' }} />
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isEstimate} onChange={(e) => setFormData({ ...formData, isEstimate: e.target.checked })} />
                      Send To Estimate Book
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isBillBook} onChange={(e) => setFormData({ ...formData, isBillBook: e.target.checked })} />
                      Send To Non GST Bill Book
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isGSTBook} onChange={(e) => setFormData({ ...formData, isGSTBook: e.target.checked })} />
                      Send To GST Bill Book
                    </label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isReceiptBook} onChange={(e) => setFormData({ ...formData, isReceiptBook: e.target.checked })} />
                      Send To Receipt Book
                    </label>
                  </div>
                  </div>
                )}
                {formData.purpose==='Subscription' && (
                  <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label htmlFor="subscriptionPeriod">Subscription Period:</label>
                    <br />
                    <input 
                      type="text" 
                      name="subscriptionPeriod" 
                      id="subscriptionPeriod" 
                      value={formData.subscriptionPeriod} 
                      placeholder="Enter period..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '50%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("subscriptionPeriod")}
                  </div>
                  </div>
                )}
                {formData.purpose==='Vaccination' && (
                  <div className="border-container">
                  <div className='mb-2 text-sm'>
                    <label htmlFor="vaccineName">Vaccine Name*:</label>
                    <br />
                    <select
                      name="vaccineName"
                      id="vaccineName"
                      value={formData.vaccineName}
                      onChange={handleChange}
                      style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px', width: '70%' }}
                    >
                      <option value="">Select a vaccine</option>
                      {vaccineOptions.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {fieldError("vaccineName")}
                  </div>
                  <div>
                    <button
                      className='bg-purple-700 mt-2'
                      onClick={handleShowVaccineSchedule}
                      style={{ maxWidth: '300px', height: '44px'}}
                    >
                      Show Vaccination Schedule
                    </button>
                  </div>
                  { showVaccineSchedule && (
                    <div className="mb-2 text-blue-700">
                          <VaccinationSchedule />
                    </div>
                  )}
                  </div>
                )}
                <div className="mb-2 text-sm">
                  <label htmlFor="taskdate">Date*:</label>
                  <br />
                  <DatePicker
                    selected={formData.taskDate}
                    onChange={date => setFormData({ ...formData, taskDate: date })}
                    dateFormat="dd/MM/yyyy"
                    id="taskdate"
                    name="taskdate"
                    className="form-control h-8"
                  />
                  {fieldError("taskdate")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="title">Title / Headline / Particulars / Item *:</label>
                  <br />
                  <input 
                    type="text" 
                    name="title" 
                    id="title" 
                    value={formData.title} 
                    placeholder="Enter the title..."
                    maxLength="100"
                    onChange={handleChange}
                    style={{
                      border: '1px solid #ccc',
                      padding: '8px',
                      width: '100%',
                      boxSizing: 'border-box',
                    }} 
                  />
                  {fieldError("title")}
                </div>
                {formData.isIkigai && ( 
                <>
                  <div className="border-container-gray">
                    <div className="mb-2 text-sm">
                      <label htmlFor="ikigaiCode">Your IKIGAI Code: </label>
                      <br />
                      <input type="text" name="ikigaiCode" id="ikigaiCode" value={formData.ikigaiCode} placeholder="Your IKIGAI Code"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                    </div>
                    <div className="mb-2 text-sm">
                        <label htmlFor="ikigaiP">Select IKIGAI Piller: </label>
                        <br />
                        <select name="ikigaiP" id="ikigaiP" value={formData.ikigaiCategory}
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                          <option value="">Select Your IKIGAI Piller</option>
                          <option value="Pillar_1">Pillar 1: Starting small → Focusing on the details</option>
                          <option value="Pillar_2">Pillar 2: Releasing yourself → Accepting who you are</option>
                          <option value="Pillar_3">Pillar 3: Harmony and sustainability → Relying on others</option>
                          <option value="Pillar_4">Pillar 4: The joy of little things → Appreciating sensory pleasure</option>
                          <option value="Pillar_5">Pillar 5: Being in the here and now → Finding your flow</option>
                        </select>
                      </div>
                  </div>
                </>
              )}
              {formData.isSugo && ( 
                <>
                  <div className="border-container-gray">
                    <div className="mb-2 text-sm">
                      <label htmlFor="sugoCode">Your Coolearth SUGO Code: </label>
                      <br />
                      <input type="text" name="sugoCode" id="sugoCode" value={formData.sugoCode} placeholder="Your SUGO Code"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                    </div>
                    <div className="mb-2 text-sm">
                        <label htmlFor="sugoCategory">Select SUGO Category: </label>
                        <br />
                        <select name="sugoCategory" id="sugoCategory" value={formData.sugoCategory}
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                          <option value="">Select Your SUGO Action Item</option>
                          <option value="Reduced">Reduced</option>
                          <option value="Reused">Reused</option>
                          <option value="Recycled">Recycled</option>
                          <option value="Reduce-Plastic-Use">Reduced Plastic Use</option>  
                          <option value="Conserved-Water">Conserved Water</option>   
                          <option value="Saved-Energy">Saved Energy</option>
                          <option value="Used-Sustainable-Transportation">Used Sustainable Transportation</option>
                          <option value="Planted-Tree">Planted Tree</option>
                          <option value="Consumed-Sustainable-Diet">Consumed Sustainable Diet</option>
                          <option value="Joined-Environmental-Groups">Joined Environmental Groups</option>
                          <option value="Promoting-Community-Gardens">Promoting Community Gardens</option>   
                          <option value="Spreading-Sustainability-Education-and-Awareness">Spreading Sustainability Education and Awareness</option>
                          <option value="Taking-Green-Initiatives">Taking Green Initiatives</option>
                          <option value="Participated-in-Sustainable-Evens">Participated in Sustainable Event</option>
                          <option value="Used-Eco-Friendly-Product">Used Eco-Friendly Product</option>
                          <option value="Supported-Renewable-Energy">Supported Renewable Energy</option> 
                          <option value="Used-Green-Technologies">Used Green Technologies</option>                                                                     
                        </select>
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="targetReduction">CO2 Reduction Target in Kg*:</label>
                      <br />
                      <input 
                        type="text" 
                        name="targetReduction" 
                        id="targetReduction" 
                        value={formData.targetReduction} 
                        placeholder="Enter the target..."
                        maxLength="100"
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '50px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("targetReduction")}
                    </div> 
                    <div className="mb-2 text-sm">
                      <label htmlFor="reducedCO2">CO2 Reduced in Kg*:</label>
                      <br />
                      <input 
                        type="text" 
                        name="reducedCO2" 
                        id="reducedCO2" 
                        value={formData.reducedCO2} 
                        placeholder="Enter value.."
                        maxLength="100"
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '50px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("reducedCO2")}
                    </div> 
                    <div>
                      <p className='text-yellow-200 mb-2 text-sm'>AI Calculated CO2 reduction value in Kg: {formData.reducedCO2}</p>
                      <button
                        className='bg-orange-700 mt-2'
                        onClick={handleCalculateCO2Score}
                        disabled={true}
                        style={{ maxWidth: '100%', height: '66px' }}
                      >
                        Ask AI to fill the above CO2 which I may have reduced
                      </button>
                    </div>
                    <div className="flex flex-col">
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.iAmTrue} onChange={(e) => setFormData({ ...formData, iAmTrue: e.target.checked })} />
                        I pledge that my entry is correct to my knowledge
                        <FontAwesomeIcon icon={faListCheck} className='text-yellow-200 text-lg ml-4'/>
                      </label>
                    </div>
                  </div>
                </>
              )}
                {formData.purpose==='Attendance' && (
                    <div className="border-container-gray ml-8">
                      <div className="mb-2 text-sm">
                        <p className='text-lg text-yellow-300'>Attendance Details:</p>
                      </div>
                      <div className="mb-2 text-sm">
                        <label htmlFor="attendeeName">Name:</label>
                        <br />
                        <input 
                          type="text" 
                          name="attendeeName" 
                          id="attendeeName" 
                          value={formData.attendeeName} 
                          placeholder="Enter name..."
                          maxLength="100"
                          onChange={handleChange}
                          style={{
                            border: '1px solid #ccc',
                            padding: '8px',
                            width: '50%',
                            boxSizing: 'border-box',
                          }} 
                        />
                        {fieldError("attendeeName")}
                      </div>
                      <div className="mb-2 text-sm">
                        <label htmlFor="attendeeName">Staus:</label>
                        <br />
                        <select name="attendanceStatus" id="attendanceStatus" value={formData.attendanceStatus}
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}>
                          <option value="">Select Status</option>
                          <option value="Present">Peresnt</option>
                          <option value="Absent">Absent</option>
                          <option value="Leave">Leave</option>
                        </select>
                        {fieldError("attendanceStatus")}
                      </div>
                      { formData.attendanceStatus === "Present" && (
                        <>
                        <div className="mb-2 text-sm">
                          <label htmlFor="rightTime">Reporting Time (hr:min AM/PM):</label>
                          <br />
                          <input 
                            type="text" 
                            name="rightTime" 
                            id="rightTime" 
                            value={formData.rightTime} 
                            placeholder="Right Time..."
                            maxLength="100"
                            onChange={handleChange}
                            style={{
                              border: '1px solid #ccc',
                              padding: '8px',
                              width: '25%',
                              boxSizing: 'border-box',
                            }} 
                          />
                          {fieldError("rightTime")}
                        </div>
                        <div className="mb-2 text-sm">
                          <label htmlFor="graceTime">Grace Time (in Minutes):</label>
                          <br />
                          <input 
                            type="text" 
                            name="graceTime" 
                            id="graceTime" 
                            value={formData.graceTime} 
                            placeholder="Grace Time..."
                            maxLength="100"
                            onChange={handleChange}
                            style={{
                              border: '1px solid #ccc',
                              padding: '8px',
                              width: '50px',
                              boxSizing: 'border-box',
                            }} 
                          />
                          {fieldError("graceTime")}
                        </div>
                        <div className="mb-2 text-sm">
                          <label htmlFor="timeIn">Time In (hr:min AM/PM):</label>
                          <br />
                          <input 
                            type="text" 
                            name="timeIn" 
                            id="timeIn" 
                            value={formData.timeIn} 
                            placeholder="Time In..."
                            maxLength="100"
                            onChange={handleChange}
                            style={{
                              border: '1px solid #ccc',
                              padding: '8px',
                              width: '100px',
                              boxSizing: 'border-box',
                            }} 
                          />
                          {fieldError("timeIn")}
                        </div>
                        <div className="mb-2 text-sm">
                          <label htmlFor="timeOut">Time Out (hr:min AM/PM):</label>
                          <br />
                          <input 
                            type="text" 
                            name="timeOut" 
                            id="timeOut" 
                            value={formData.timeOut} 
                            placeholder="Time Out..."
                            maxLength="100"
                            onChange={handleChange}
                            style={{
                              border: '1px solid #ccc',
                              padding: '8px',
                              width: '100px',
                              boxSizing: 'border-box',
                            }} 
                          />
                          {fieldError("timeOut")}
                        </div>
                        <div className="mb-2 text-sm text-white">
                          <p>In Time Status: </p>
                          {/* <p>In Time Status: {calculateTimeStatus(formData.timeIn)}</p> */}
                        </div>
                        <div className="mb-2 text-sm text-white">
                          <p>Out Time Status: </p>
                          {/* <p>Out Time Status: {calculateTimeStatus(formData.timeOut)}</p> */}
                        </div>                       
                        </>
                      )}
                    </div>
                )}
                {formData.purpose==='Routine Diet' && (
                  <div className="ml-2 mr-2 mb-2 text-sm flex flex-row">
                    <label htmlFor="qty">Qty: </label>
                    <br />
                    <input type="text" name="qty" id="qty" value={formData.qty} placeholder="Qty"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '80px' }} />
                    <label className="ml-4" htmlFor="">Unit: </label>
                    <br />
                    <input type="text" name="unit" id="unit" value={formData.unit} placeholder="Unit"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                  </div>
                )}
                {formData.purpose==='LifeResources' && (
                  <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label htmlFor="lrAmount">Amount: </label>
                    <br />
                    <input type="text" name="lrAmount" id="lrAmount" value={formData.lrAmount} placeholder="Amount"
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                    {fieldError("lrAmount")}
                  </div>
                  </div>
                )}
                <div className="mb-2 text-sm">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isToDo} onChange={(e) => setFormData({ ...formData, isToDo: e.target.checked })} />
                    Save as ToDo
                  </label>
                  {formData.isToDo && (
                    // <div className="mb-2 text-sm">
                      <label>
                        <input className='ml-8 mr-4' type="checkbox" checked={formData.isDone} onChange={(e) => setFormData({ ...formData, isDone: e.target.checked })} />
                        <span className='text-yellow-300'>Its Done</span>
                      </label>
                    // </div>
                  )}
                </div>
              </div>
              <div className="border-container">
                <div className="mb-2 text-sm text-white">
                    <p>Description*:</p>
                    { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="for Description"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          placeholder="Click Mic and Speak or Talk for Voice Input..."
                          maxLength="2000"
                        />
                    ) : (
                      <textarea 
                        type="description" 
                        name="description" 
                        id="description" 
                        value={formData.description}
                        placeholder={showMicrophoneAlert ? "Write here or Click Mic for Voice Input...":"Write here.."}
                        onChange={handleChange}
                        maxLength="2000"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          maxWidth: '100%', 
                          maxHeight: '150px' 
                        }}
                      />
                    )}
                  {fieldError("description")}
                  {isCheckedAISupport && formData.description!== '' && (
                    <div className="mb-1">
                      <AILightComponent param1={"Life Chronicle "+formData.purpose} param2={formData.description}/>
                    </div>
                    )}
                    {formData.isSecret && ( 
                      <div className="border-container">
                        <div className="mb-2 text-sm">
                          <label htmlFor="secretKey">Your Secret Key: </label>
                          <br />
                          <input type="text" name="secretKey" id="secretKey" value={formData.secretKey} placeholder="Your Secret Key"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                          {fieldError("secretKey")}
                        </div>
                        {/* Test Starts */}
                        <div>
                          <h2>Encryption and Decryption</h2>
                          <div>
                              <button onClick={handleEncrypt}>Encrypt</button>
                          </div>
                          <div>
                            <label>
                              Encrypted Text:
                              <textarea
                                value={encryptedText}
                                readOnly
                                style={{
                                  border: '1px solid #ccc',
                                  padding: '2px',
                                  backgroundColor: '#f0f0f0', 
                                  color: '#000000',
                                  maxWidth: '100%', 
                                  maxHeight: '150px' 
                                }}
                              />
                            </label>
                          </div>
                          {encryptedText && (
                              <div className='text-white'>
                                  <button onClick={handleDecrypt}>Decrypt</button>
                              </div>
                          )}
                          {decryptedText && (
                              <div>
                                  <h3>Decrypted Text</h3>
                                  <textarea
                                    value={decryptedText}
                                    readOnly
                                    style={{
                                      border: '1px solid #ccc',
                                      padding: '2px',
                                      backgroundColor: '#f0f0f0', 
                                      color: '#000000',
                                      maxWidth: '100%', 
                                      maxHeight: '150px' 
                                    }}
                                  />
                              </div>
                          )}
                        </div>
                      </div>
                    )}
                </div>
                { formData.purpose=='Monthly Essentials Plan' && (
                    <div className='border-2 bg-green-900'>
                      {/* <div className="ml-2 mr-2 mb-2 text-sm">
                        <label htmlFor="act">Main: </label>
                        <br />
                        <input type="text" name="act" id="act" value={formData.act} placeholder="Act"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }} />
                      </div> */}
                      {/* <div className="ml-2 mr-2 mb-2 text-sm">
                        <label htmlFor="subAct">Sub: </label>
                        <br />
                        <input type="text" name="subAct" id="subAct" value={formData.subAct} placeholder="Sub act"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '40%' }} />
                      </div> */}
                      {/* <div className="ml-2 mr-2 mb-2 text-sm">
                        <label htmlFor="actTime">Time (hr:min:sec AM/PM): </label>
                        <br />
                        <input type="text" name="actTime" id="actTime" value={formData.actTime} placeholder="hr:min:sec AM/PM"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '35%' }} />
                      </div> */}
                      {/* <div className="ml-2 mr-2 mb-2 text-sm">
                        <label htmlFor="actDuration">Duration (hr:min:sec): </label>
                        <br />
                        <input type="text" name="actDuration" id="actDuration" value={formData.actDuration} placeholder="hr:min:sec"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                      </div> */}
                      <div className="ml-2 mt-2 mb-2 text-sm flex flex-row">
                        <label htmlFor="qty">Qty: </label>
                        <br />
                        <input type="text" name="qty" id="qty" value={formData.qty} placeholder="Qty"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '80px' }} />
                        <label className="ml-4" htmlFor="">Unit: </label>
                        <br />
                        <input type="text" name="unit" id="unit" value={formData.unit} placeholder="Unit"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                      </div>
                      <div className="mt-2 mb-2 ml-2 text-sm flex flex-row">
                        <label htmlFor="amount">Budgeted Amount: </label>
                        <br />
                        <input type="text" name="amount" id="amount" value={formData.amount} placeholder="Amount"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                        <label className="ml-4" htmlFor="currency">Currency: </label>
                        <br />
                        <input type="text" name="currency" id="currency" value={formData.currency} placeholder="Currency"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '25px' }} />
                      </div>
                      <div className="ml-2 mr-2 mb-2 text-sm">
                        <label htmlFor="actSplRemarks">Special Remarks: </label>
                        <br />
                        <input type="text" name="actSplRemarks" id="actSplRemarks" value={formData.actSplRemarks} placeholder="Special Remarks"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '75%' }} />
                      </div>
                    </div>
                  )}
                  {(formData.purpose === 'Buy' || formData.purpose === 'Sales' || formData.purpose === 'Service') && (
                  <div className="border-container">
                    <div className="mb-2 text-sm">
                      <label htmlFor="serialNumberByUser">Your Serial / Bill / Receipt Number:</label>
                      <br />
                      <input 
                        type="text" 
                        name="serialNumberByUser" 
                        id="serialNumberByUser" 
                        value={formData.serialNumberByUser} 
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '250px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("serialNumberByUser")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="reply">Your Reply:</label>
                      <br />
                      <textarea 
                        type="text" 
                        name="reply" 
                        id="reply" 
                        value={formData.reply} 
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          height: '150px' 
                        }}
                      />
                      {fieldError("reply")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="feedback">Your Feedback:</label>
                      <br />
                      <textarea 
                        type="text" 
                        name="feedback" 
                        id="feedback" 
                        value={formData.feedback} 
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          height: '150px' 
                        }} 
                      />
                      {fieldError("feedback")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="subscriptionPeriod">Rating:</label>
                      <br />
                      <input 
                        type="number" 
                        name="rating" 
                        id="rating" 
                        value={formData.rating} 
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '50px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("rating")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="statusCommment">Current Status & Comment:</label>
                      <br />
                      <textarea 
                        type="text" 
                        name="status" 
                        id="status" 
                        value={formData.status} 
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          backgroundColor: '#f0f0f0',
                          padding: '8px',
                          width: '100%',
                          height: '150px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("status")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="statusDate">Status Date:</label>
                      <br />
                      <DatePicker
                        selected={formData.statusDate}
                        onChange={date => setFormData({ ...formData, statusDate: date })}
                        dateFormat="dd/MM/yyyy"
                        id="statusDate"
                        name="statusDate"
                        className="form-control h-8"
                      />
                      {fieldError("statusDate")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="statusCommment">Your Comment on Status:</label>
                      <br />
                      <textarea 
                        type="text" 
                        name="statusCommment" 
                        id="statusCommment" 
                        value={formData.statusCommment} 
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          width: '100%', 
                          height: '150px' 
                        }}
                      />
                      {fieldError("statusCommment")}
                    </div>
                    <div className="mb-2 text-sm">
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPreorder} onChange={(e) => setFormData({ ...formData, isPreorder: e.target.checked })} />
                        It Is Preorder
                      </label>
                    </div>
                  </div>
                )}  
                <div className="mb-2 text-sm">
                  <label htmlFor="tags">Tags / Keyword:</label>
                  <br />
                  <input type="text" name="tags" id="tags" value={formData.tags} placeholder="Enter tags or keywords seperated by a comma (,) ..."
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '44px' }} />
                  {fieldError("tags")}
                </div>
                <div className="mb-2 text-sm">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isDiary} onChange={(e) => setFormData({ ...formData, isDiary: e.target.checked })} />
                    Save to Diary
                  </label>
                </div>
                {formData.isDiary && ( 
                  <div className="border-container">
                    <div className="mb-2 text-sm">
                      <label htmlFor="diaryType">Diary Type: </label>
                      <br />
                      <select name="diaryType" id="diaryType" value={formData.diaryType}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px' }}>
                        <option value="">Select Diary Type</option>
                        <option value="Personal">Default / Personal</option>
                        <option value="Children">Children</option>
                        <option value="Couple">Couple</option>
                        <option value="Elders">Elders</option>
                        <option value="Kids">Kids</option>
                        <option value="Family">Family</option>
                        <option value="Friends">Friends</option>
                        <option value="Men">Men</option>
                        <option value="Motherhood">Motherhood</option>
                        <option value="Teenagers">Teenagers</option>
                        <option value="Wellness">Wellness</option>
                        <option value="Women">Women</option>
                      </select>
                      {fieldError("diaryType")}
                    </div>
                    { formData.diaryType=='Couple' && (
                      <div className='border-2 border-blue-400'>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="act">Main: </label>
                          <br />
                          <input type="text" name="act" id="act" value={formData.act} placeholder="Act"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="subAct">Sub: </label>
                          <br />
                          <input type="text" name="subAct" id="subAct" value={formData.subAct} placeholder="Sub act"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '40%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="actTime">Time (hr:min:sec AM/PM): </label>
                          <br />
                          <input type="text" name="actTime" id="actTime" value={formData.actTime} placeholder="hr:min:sec AM/PM"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '35%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="actDuration">Duration (hr:min:sec): </label>
                          <br />
                          <input type="text" name="actDuration" id="actDuration" value={formData.actDuration} placeholder="hr:min:sec"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="actSplRemarks">Special Remarks: </label>
                          <br />
                          <input type="text" name="actSplRemarks" id="actSplRemarks" value={formData.actSplRemarks} placeholder="Special Remarks"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '75%' }} />
                        </div>
                      </div>
                    )}
                    { formData.diaryType=='Friends' && (
                      <div className='border-2 border-blue-400'>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="act">Main: </label>
                          <br />
                          <input type="text" name="act" id="act" value={formData.act} placeholder="Act"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="subAct">Sub: </label>
                          <br />
                          <input type="text" name="subAct" id="subAct" value={formData.subAct} placeholder="Sub act"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '40%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="actTime">Time (hr:min:sec AM/PM): </label>
                          <br />
                          <input type="text" name="actTime" id="actTime" value={formData.actTime} placeholder="hr:min:sec AM/PM"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '35%' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="actDuration">Duration (hr:min:sec): </label>
                          <br />
                          <input type="text" name="actDuration" id="actDuration" value={formData.actDuration} placeholder="hr:min:sec"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                        </div>

                        <div className="ml-2 mr-2 mb-2 text-sm flex flex-row">
                          <label htmlFor="amount">Amount: </label>
                          <br />
                          <input type="text" name="amount" id="amount" value={formData.amount} placeholder="Amount"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                          <label className="ml-4" htmlFor="currency">Currency: </label>
                          <br />
                          <input type="text" name="currency" id="currency" value={formData.currency} placeholder="Currency"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '75px' }} />
                        </div>
                        <div className="ml-2 mr-2 mb-2 text-sm flex flex-row">
                          <label htmlFor="qty">Qty: </label>
                          <br />
                          <input type="text" name="qty" id="qty" value={formData.qty} placeholder="Qty"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '80px' }} />
                          <label className="ml-4" htmlFor="">Unit: </label>
                          <br />
                          <input type="text" name="unit" id="unit" value={formData.unit} placeholder="Unit"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} />
                        </div>


                        <div className="ml-2 mr-2 mb-2 text-sm">
                          <label htmlFor="actSplRemarks">Special Remarks: </label>
                          <br />
                          <input type="text" name="actSplRemarks" id="actSplRemarks" value={formData.actSplRemarks} placeholder="Special Remarks"
                            onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '75%' }} />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="text-sm">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isJournal} onChange={(e) => setFormData({ ...formData, isJournal: e.target.checked })} />
                    Save to Journal
                  </label>
                </div>
                <div className="text-sm flex flex-col">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isHealthCard} onChange={(e) => setFormData({ ...formData, isHealthCard: e.target.checked })} />
                    Save to HealthCard
                  </label>
                  {formData.isHealthCard && (
                    <>
                      <label htmlFor="cardHolderCode">Person Think5Whys Code*:</label>
                      <br />
                      <input 
                        type="text"
                        name="cardHolderCode" 
                        id="cardHolderCode" value={formData.cardHolderCode} placeholder="Input Think5Whys Code"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} />
                      {fieldError("cardHolderCode")}
                    </> 
                  )}
                </div>
                <div className="text-sm flex flex-col">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isPetCare} onChange={(e) => setFormData({ ...formData, isPetCare: e.target.checked })} />
                    Save to PetCare
                  </label>
                  {formData.isPetCare && (
                    <>
                      <p htmlFor="vaccineName">Pet Name*:</p>
                      <br />
                      <input 
                        type="text"
                        name="petName" 
                        id="petName" value={formData.petName} placeholder="Input Pet Name"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '300px' }} />
                      {fieldError("petName")}
                    </> 
                  )}
                </div>

                {formData.isJournal && ( 
                  <div className="border-container">
                    <div className="mb-2 text-sm">
                      <label htmlFor="journalType">Journal Type: </label>
                      <br />
                      <select name="journalType" id="journalType" value={formData.journalType}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px' }}>
                        <option value="">Select Journal</option>
                        <option value="Personal">Personal</option>
                        <option value="Work">Work / Job</option>
                        <option value="Social">Social</option>
                        <option value="Support">Support</option>                        
                      </select>
                      {fieldError("journalType")}
                    </div>
                  </div>
                )}
                { (formData.purpose=== 'Task' || formData.purpose=== 'Event') && (
                  <div className="border-container">
                    <div className="mb-2 text-sm">
                      <label>{formData.purpose} Time / Start Time:</label>
                      <br />
                      <DatePicker
                        selected={startTime ? new Date(startTime) : null}
                        onChange={handleStartDateChange}    //{(date) => setStartTime(date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        placeholderText="Select"
                        className="form-control h-8"
                        style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }}
                      />
                    </div>
                    <div className="mb-2 text-sm">
                      <label>{formData.purpose} End Time:</label>
                      <br />
                      <DatePicker
                        selected={endTime ? new Date(endTime) : null}
                        onChange={(date) => setEndTime(date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        placeholderText="Select"
                        className="form-control h-8"
                        style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }}
                      />
                    </div>
                  </div>
                )}
              {/* </div> */}
              {/* <div className="border-container"> */}
                {/* <div className="text-sm flex flex-col">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isHealthCard} onChange={(e) => setFormData({ ...formData, isHealthCard: e.target.checked })} />
                    Save to HealthCard
                  </label>
                  {formData.isHealthCard && (
                    <>
                      <label htmlFor="cardHolderCode">Person Think5Whys Code*:</label>
                      <br />
                      <input 
                        type="text"
                        name="cardHolderCode" 
                        id="cardHolderCode" value={formData.cardHolderCode} placeholder="Input Think5Whys Code"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} />
                      {fieldError("cardHolderCode")}
                    </> 
                  )}
                </div> */}
              {/* </div>
              <div className="border-container"> */}
                {/* <div className="text-sm flex flex-col">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isPetCare} onChange={(e) => setFormData({ ...formData, isPetCare: e.target.checked })} />
                    Save to PetCare
                  </label>
                  {formData.isPetCare && (
                    <>
                      <label htmlFor="vaccineName">Pet Name*:</label>
                      <br />
                      <input 
                        type="text"
                        name="petName" 
                        id="petName" value={formData.petName} placeholder="Input Pet Name"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '300px' }} />
                      {fieldError("petName")}
                    </> 
                  )}
                </div> */}
              </div>
              {/* {formData.isKaizen?"Kaizen clicked":"Kaizen not clicked"} */}
              {/* {formData.showDetailForm?"showDetailForm":"showDetailForm not clicked"} */}
              {formData.isKaizen && ( 
                <>
                  <div className="border-container-gray">
                    <div className="mb-2 text-sm">
                      <label htmlFor="kaizencode">Your KAIZEN Code: </label>
                      <br />
                      <input type="text" name="kaizencode" id="kaizencode" value={formData.kaizenCode} placeholder="Your KAZIZEN Code"
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                    </div>
                    <div className="mb-2 text-sm">
                        <label htmlFor="kaizenCategory">Category: </label>
                        <br />
                        <select name="kaizenCategory" id="kaizenCategory" value={formData.kaizenCategory}
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                          <option value="">Select KAIZEN Category</option>
                          <option value="Personal">Personal</option>
                          <option value="Family">Family</option>
                          <option value="Student">Student</option>
                          <option value="Children">Children</option>
                          <option value="Parent">Parent</option>
                          <option value="Professional">Profesional</option>
                          <option value="Social">Social</option>
                          <option value="Worker">Worker</option>
                          <option value="Operator">Operator</option>
                          <option value="Factory">Factory</option>
                          <option value="Manager">Manager</option>
                          <option value="Engineer">Engineer</option>
                          <option value="Healthcare">Healthcare</option>
                          <option value="Business">Business</option>
                          <option value="Government">Government</option>
                          <option value="Institution">Institution</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                  </div>
                </>
              )}
              {formData.isRisk && ( 
                <>
                  <div className="border-container-gray">
                    <div className="mb-2 text-sm">
                      <p className='text-lg text-yellow-200'>Risk Analysis of {formData.purpose}: </p>
                      <br />
                    </div>
                    <div className="mb-2 text-sm">
                      <label htmlFor="riskTitle">Title/Name of the Risk*:</label>
                      <br />
                      <input 
                        type="text" 
                        name="riskTitle" 
                        id="riskTitle" 
                        value={formData.riskTitle} 
                        placeholder="Enter risk title..."
                        maxLength="200"
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '8px',
                          width: '90%',
                          height: '44px',
                          boxSizing: 'border-box',
                        }} 
                      />
                      {fieldError("riskTitle")}
                    </div> 
                  <div className="mb-2 text-sm">
                      <label htmlFor="riskLikelihood">Select Risk Likelihood: </label>
                      <br />
                      <select name="riskLikelihood" id="riskLikelihood" value={formData.riskLikelihood}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                        <option value="">Select Risk Likelihood</option>
                        <option value="5_Almost-Certain">5. Almost Certain</option>
                        <option value="4_Likely">4. Likely</option>   
                        <option value="3_Moderate">3. Moderate</option>
                        <option value="2_Unlikely">2. Unlikely</option>
                        <option value="1_Rare">1. Rare</option>
                      </select>
                      {fieldError("riskLikelihood")}
                  </div>
                  <div className="mb-2 text-sm">
                      <label htmlFor="riskImpact">Select Risk Impact: </label>
                      <br />
                      <select name="riskImpact" id="riskImpact" value={formData.riskImpact}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                        <option value="">Select Risk Impact</option>
                        <option value="1_Insignificant">1. Insignificant</option>
                        <option value="2_Minor">2. Minor</option>   
                        <option value="3_Significant">3. Significant</option>
                        <option value="4_Major">4. Major</option>
                        <option value="5_Severe">5. Severe</option>
                      </select>
                      {fieldError("riskImpact")}
                  </div>
                  <div>
                    <button
                      className='bg-orange-700 mt-2'
                      onClick={handleCalculateRiskScore}
                      style={{ maxWidth: '300px', height: '66px' }}
                    >
                      Calculate Risk Score & View Risk Level
                    </button>
                  </div>
                  { calculateRiskScore && (
                    <div className="flex flex-col mb-2 text-sm text-white">
                      <p className='text-lg'>Risk Score : <strong>{formData.riskScore}</strong></p>
                      <p className='text-lg'>Risk Level : <strong>{formData.riskLevel}</strong></p>
                      <p className='text-yellow-200'>We caution you against taking any decision on the above Risk Score and Risk Level. This is a probable indication. Verify other parameters before taking any final decision.</p>
                      <button
                        className='bg-purple-700 mt-2'
                        onClick={handleShowRiskMatrix}
                        style={{ maxWidth: '300px', height: '44px'}}
                      >
                        Show Risk Score Matrix
                      </button>
                      
                    </div>
                  )}
                  { showRiskMatrix && (
                    <div className="mb-2 text-blue-700">
                          <RiskMatrixTable />
                    </div>
                  )}
                  <div className="mb-2 text-sm">
                    <label htmlFor="riskMitigations">Mitigations:</label>
                    <textarea 
                      type="riskMitigations" 
                      name="riskMitigations" 
                      id="riskMitigations" 
                      value={formData.riskMitigations}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("riskMitigations")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="riskRemarks">Additional Remarks:</label>
                    <textarea 
                      type="text" 
                      name="riskRemarks" 
                      id="riskRemarks" 
                      value={formData.riskRemarks}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("riskRemarks")}
                  </div>
                </div>
                </>
              )}
              {formData.isOpportunity && ( 
                <>
                <div className="border-container-gray">
                  <div className="mb-2 text-sm">
                    <p className='text-lg text text-yellow-200'>Opportunity Check for {formData.purpose} </p>
                    <br />
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="oppTitle">Title/Name of the Opportunity*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="oppTitle" 
                      id="oppTitle" 
                      value={formData.oppTitle} 
                      placeholder="Enter opportunity title..."
                      maxLength="200"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '90%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("oppTitle")}
                  </div> 
                  <div className="mb-2 text-sm">
                    <label htmlFor="oppPassionScore">Passion/Interest Score (1-100)*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="oppPassionScore" 
                      id="oppPassionScore" 
                      value={formData.oppPassionScore} 
                      placeholder="Enter passion score..."
                      maxLength="200"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '25%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("oppPassionScore")}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="oppProfitScore">Profit/Benefit Score (1-100)*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="oppProfitScore" 
                      id="oppProfitScore" 
                      value={formData.oppProfitScore} 
                      placeholder="Enter passion score..."
                      maxLength="200"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '25%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("oppProfitScore")}
                  </div>
                  <div>
                    <button
                      className="bg-green-700 mt-2"
                      onClick={handleCalculateOppScore}
                      style={{height: '68px'}}
                    >
                      Calculate Opportunity Score & Opportunity Comment
                    </button>
                    { calculateOppScore && (
                      <div className="flex flex-col mb-2 text-sm text-white">
                        {/* <p className='text-lg'>Opportunity Score : <strong>{formData.oppScore}</strong></p> */}
                        <p className='text-lg'>Comment : <strong>{formData.oppComment}</strong></p>
                        <p className='text-yellow-200'>We caution you against taking any decision on the above Opportunity Score and Comment. This is a probable indication. Verify other parameters before taking any final decision.</p>
                        <button
                          className='bg-purple-700 mt-2'
                          onClick={handleShowOppMatrix}
                          style={{ maxWidth: '300px', height: '48px'}}
                        >
                          Show Opportunity Score Matrix
                        </button>
                        
                      </div>
                    )}
                    { showOppMatrix && (
                      <div className="mb-2 text-blue-700">
                            <OppMatrixTable />
                      </div>
                    )}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="oppRemarks">Additional Remarks:</label>
                    <textarea 
                      type="text" 
                      name="oppRemarks" 
                      id="oppRemarks" 
                      value={formData.oppRemarks}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                  />
                  {fieldError("oppRemarks")}
                </div>
              </div>
              </>
              )}
              { showDetailForm && (
                <>
                <div className="border-container-gray">
                  <div className="mb-2 text-sm">
                    <label htmlFor="name" className='text-yellow-400'>These are optional additional entries</label>
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="actualDate">Actual Finish Date*:</label>
                    <br />
                    <DatePicker
                      selected={formData.actualDate}
                      onChange={date => setFormData({ ...formData, actualDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="actualDate"
                      name="actualDate"
                      className="form-control h-8"
                    />
                    {fieldError("actualDate")}
                  </div>
                  <div className="mb-2 text-sm text-white">
                    {(() => {
                      const { actualDate, taskDate } = formData;

                      // Helper function to calculate the date difference in days
                      const getDifferenceMessage = (actualDate, taskDate) => {
                        if (!actualDate || !taskDate) {
                          return '';
                        }

                        const actual = new Date(actualDate);
                        const task = new Date(taskDate);
                        const timeDiff = actual - task; // Difference in milliseconds
                        const diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days

                        if (isNaN(diffDays)) {
                          return '';
                        } else if (diffDays < 0) {
                          return `Before Time by ${Math.abs(diffDays)} Days`;
                        } else if (diffDays === 0) {
                          return 'On Time';
                        } else {
                          return `Overrun By ${diffDays} Days`;
                        }
                      };

                      return (
                        <p htmlFor="actualDate">
                          Difference: <strong>{getDifferenceMessage(actualDate, taskDate)}</strong>
                        </p>
                      );
                    })()}
                  </div>
                  <div className="mb-2 text-sm">
                    <label htmlFor="enddate">End Date:</label>
                    <br />
                    <DatePicker
                      selected={formData.endDate}
                      onChange={(date) => setFormData({ ...formData, endDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="endDate"
                      name="endDate"
                      className="form-control h-8"
                    />
                    {fieldError("enddate")}
                  </div>
                  {/* <div className="mb-2 text-sm">
                    <label>Time / Start Time:</label>
                    <br />
                    <DatePicker
                      selected={startTime ? new Date(startTime) : null}
                      onChange={handleStartDateChange}    //{(date) => setStartTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select"
                      className="form-control h-8"
                      style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }}
                    />
                  </div>
                  <div className="mb-2 text-sm">
                    <label>End Time:</label>
                    <br />
                    <DatePicker
                      selected={endTime ? new Date(endTime) : null}
                      onChange={(date) => setEndTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select"
                      className="form-control h-8"
                      style={{ border: '1px solid #ccc', padding: '8px', width: '50%' }}
                    />
                  </div> */}
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={additionalDataEntry} onChange={handleAddlCheckboxChange} />
                      Check Here For Additional Information
                    </label>
                  </div>

                  {additionalDataEntry && ( 
                    <>
                      <div className="mb-2 text-sm">
                        <label htmlFor="name">Name: </label>
                        <br />
                        <input type="text" name="name" id="name" value={formData.name} placeholder="Enter person or team or entity name..."
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                        {fieldError("name")}
                      </div>
                      <div className="mb-2 text-sm">
                        <label htmlFor="place">Place: </label>
                        <br />
                        <input type="text" name="place" id="place" value={formData.place} placeholder="Place (Optional)"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                        {fieldError("place")}
                      </div>
                      <div className="mb-2 text-sm">
                        <label htmlFor="category">Category: </label>
                        <br />
                        <input type="text" name="category" id="category" value={formData.category} placeholder="Data Category (Optional)"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '80%' }} />
                        {fieldError("category")}
                      </div>
                      <div className="mb-2 text-sm">
                        <label htmlFor="subcategory">Sub-Category: </label>
                        <br />
                        <input type="text" name="subcategory" id="subcategory" value={formData.subcategory} placeholder="Data Sub-Category (Optional)"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '80%' }} />
                        {fieldError("subcategory")}
                      </div>
                      <div className="mb-2 text-sm">
                        <label htmlFor="amount">Amount:</label>
                        <br />
                        <input
                          type="text"
                          name="amount"
                          id="amount"
                          value={formData.amount}
                          onChange={handleChange}
                          style={{ border: '1px solid #ccc', padding: '8px', width: '20%' }}
                        />
                        {fieldError("amount")}
                      </div>

                      <div className="mb-2 text-sm">
                        <label htmlFor="currency">Currency:</label>
                        <br />
                        <input
                          type="text"
                          name="currency"
                          id="currency"
                          value={formData.currency}
                          placeholder="Rs."
                          onChange={handleChange}
                          style={{ border: '1px solid #ccc', padding: '8px', width: '15%' }}
                        />
                        {fieldError("currency")}
                      </div>
                    </>
                  )}
                </div>
                
                {/* <div className="border-container-gray">
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isSecret} onChange={(e) => setFormData({ ...formData, isSecret: e.target.checked })} />
                      It is Secret 
                    </label>
                  </div>
                  {formData.isSecret && ( 
                    <>
                      <div className="mb-2 text-sm">
                        <label htmlFor="secretKey">Your Secret Key: </label>
                        <br />
                        <input type="text" name="secretKey" id="secretKey" value={formData.secretKey} placeholder="Your Secret Key"
                          onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '30%' }} />
                        {fieldError("secretKey")}
                      </div>
                    </>
                  )}
                </div> */}
                <div className="border-container-gray">
                  <div className="mb-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isFlagged} onChange={(e) => setFormData({ ...formData, isFlagged: e.target.checked })} />
                      Flagged
                    </label>
                  </div>

                  <div className="mb-2 text-sm">
                    <label htmlFor="currentStatus">Current Status:</label>
                    <br />
                    <select name="currentStatus" id="currentStatus" value={formData.currentStatus}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px' }}>
                      <option value="">Select Status Type</option>
                      <option value="Planned">Planned</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Completed">Completed</option>  
                      {(formData.purpose === 'Buy' || formData.purpose === 'Sale' || formData.purpose === 'Service') && (
                          <>
                          <option value="New">New</option>
                          <option value="Working">Working</option>
                          <option value="Closed">Closed</option>
                          </>
                      )}                  
                    </select>
                    {fieldError("currentStatus")}
                  </div>
                  
                  <div className="mb-2 text-sm">
                    <label htmlFor="remarks">Remarks:</label>
                    <br />
                    <input type="text" name="remarks" id="remarks" value={formData.remarks} placeholder="Enter remarks..."
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                    {fieldError("remarks")}
                  </div>
                </div>
                <div className="border-container">
                  <div className="mb-2 text-sm">
                    <label>
                    <input className='mr-4' type="checkbox" checked={formData.isPublic} onChange={(e) => setFormData({ ...formData, isPublic: e.target.checked })} />
                    Visible to Public ?
                    </label>
                  </div>
                </div>
                <div className="border-container text-sm">
                  <div className='mb-2 text-sm'>  
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isShared} onChange={(e) => setFormData({ ...formData, isShared: e.target.checked })} />
                      Shared?
                    </label>
                  </div>    
                  { formData.isShared && ( 
                    <> 
                    <div className="flex flex-col justify-center text-white text-sm">
                        <p>Pair:</p>
                        <input
                          type="text"
                          className="profile-input text-black"
                          style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                          value={formData.pairCode}
                          onChange={(e) => setFormData({ ...formData, pairCode: e.target.value })}
                          placeholder="Enter pair code"
                        />
                        {/* <button
                          className='bg-orange-700 mt-2'
                          onClick={handlePairCodeVerifyClick}
                          disabled={pairCodeVerified}
                          style={{ maxWidth: '300px', height: '34px', lineHeight: '24px' }}
                        >
                          Verify Pair Code To Share This RCA
                        </button> */}
                      </div>
                      <div className="flex flex-col justify-center text-white">
                        <p>Team:</p>
                        <input
                          type="text"
                          className="profile-input text-black"
                          style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                          value={formData.teamCode}
                          onChange={(e) => setFormData({ ...formData, teamCode: e.target.value })}
                          placeholder="Enter team code"
                        />
                        {/* <button
                          className='bg-orange-700 mt-2'
                          onClick={handleTeamCodeVerifyClick}
                          disabled={teamCodeVerified}
                          style={{ maxWidth: '300px', height: '34px', lineHeight: '24px' }}
                        >
                          Verify Team Code To Share This RCA
                        </button> */}
                      </div>
                    </>
                  )}
                  </div>
                  <div className="border-container text-sm">
                    <div className="flex flex-col justify-center text-white">
                        <p>Life Stage / Life Chunk / Life Segment Code :</p>
                        <input
                          type="text"
                          className="profile-input text-black"
                          style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                          value={formData.lifeChunkCode}
                          onChange={(e) => setFormData({ ...formData, lifeChunkCode: e.target.value })}
                          placeholder="Enter life stage/chunk code"
                        />
                        {/* <button
                          className='bg-orange-700 mt-2'
                          onClick={handleLifeChunkCodeVerifyClick}
                          disabled={lifeChunkCodeVerified}
                          style={{ maxWidth: '300px', height: '34px', lineHeight: '24px' }}
                        >
                          Verify Life Stage/Chunk Code
                        </button> */}
                      </div>
                  </div>
                  <div className="text-sm border-container flex flex-col justify-center border-b border-b-gray-300 ml-2">
                    <div className="flex flex-col justify-center text-white mb-2">
                      <p>Project:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                        value={formData.projectCode}
                        onChange={(e) => setFormData({ ...formData, projectCode: e.target.value })}
                        placeholder="Enter project code"
                      />
                      {/* <button
                        className='bg-orange-700 mt-2'
                        onClick={handleProjectCodeVerifyClick}
                        disabled={projectCodeVerified}
                        style={{ maxWidth: '300px', height: '34px', lineHeight: '24px' }}
                      >
                        Verify Project Code
                      </button> */}
                    </div>
                    <div className="flex flex-col justify-center text-white mb-2">
                      <p>Process:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                        value={formData.processCode}
                        onChange={(e) => setFormData({ ...formData, processCode: e.target.value })}
                        placeholder="Enter process code"
                      />
                      {/* <button
                        className='bg-orange-700 mt-2'
                        onClick={handleProcessCodeVerifyClick}
                        disabled={processCodeVerified}
                        style={{ maxWidth: '300px', height: '34px', lineHeight: '24px' }}
                      >
                        Verify Process Code
                      </button> */}
                    </div>
                    <div className="flex flex-col justify-center text-white mb-2">
                      <p>Location (Factory, Branch, Machine etc):</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                        value={formData.factoryCode}
                        onChange={(e) => setFormData({ ...formData, factoryCode: e.target.value })}
                        placeholder="Enter location code"
                      />
                      {/* <button
                        className='bg-orange-700 mt-2'
                        onClick={handleProcessCodeVerifyClick}
                        disabled={processCodeVerified}
                        style={{ maxWidth: '300px', height: '34px', lineHeight: '24px' }}
                      >
                        Verify Process Code
                      </button> */}
                    </div>
                    <div className="flex flex-col justify-center text-white mb-2">
                      <p className='mt-1 text-white'>Linked RCA Code:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '200px', height: '34px', lineHeight: '24px' }}
                        value={formData.rcaCode}
                        onChange={(e) => setFormData({ ...formData, rcaCode: e.target.value })}
                        placeholder="Enter RCA Linking Code"
                      />
                      {/* <button
                        className='bg-orange-700 mt-2'
                        onClick={handleRCALinkCodeVerifyClick}
                        disabled={rcaLinkCodeVerified}
                        style={{ maxWidth: '350px', height: '34px', lineHeight: '24px' }}
                        >
                        Verify The RCA Code To Link With That RCA
                      </button> */}
                    </div>
                  </div>
                  <div className="border-container">
                    <div className="text-sm flex flex-col justify-center text-white">
                      <p>Linked Task (Parent Task) Code:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '200px', height: '34px', lineHeight: '24px' }}
                        value={formData.taskLinkCode}
                        onChange={(e) => setFormData({ ...formData, taskLinkCode: e.target.value })}
                        placeholder="Enter Linked Task Code"
                      />
                      {/* <button
                        className='bg-orange-700 mt-2'
                        onClick={handleTaskCodeVerifyClick}
                        disabled={taskCodeVerified}
                        style={{ maxWidth: '200px', height: '34px', lineHeight: '24px' }}
                      >
                        Verify Task Code To Link
                      </button> */}
                    </div>
                    <div className="text-sm flex flex-col justify-center text-white">
                      <p>Own Task Group Code (for AI Counselling Data Pull):</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '200px', height: '34px', lineHeight: '24px' }}
                        value={formData.taskGroupCode}
                        onChange={(e) => setFormData({ ...formData, taskGroupCode: e.target.value })}
                        placeholder="Enter Task Group Code"
                      />
                      {/* <button
                        className='bg-orange-700 mt-2'
                        onClick={handleTaskCodeVerifyClick}
                        disabled={taskCodeVerified}
                        style={{ maxWidth: '200px', height: '34px', lineHeight: '24px' }}
                      >
                        Verify Task Code To Link
                      </button> */}
                    </div>
                  </div>
                  </>
                )}
                <div className="border-container">
                  <div className='mb-2 text-sm'>  
                    <label>
                      <input 
                        className='mr-4' 
                        type="checkbox" 
                        checked={formData.isProcessifyd} 
                        onChange={(e) => setFormData({ ...formData, isProcessifyd: e.target.checked })} 
                      />
                      Processifyd
                    </label>
                  </div>    
                </div>
                <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>

                  { mode == 'update' && (
                      <div>
                      <label>
                        <input 
                          className='mr-4' 
                          type="checkbox" 
                          checked={isUpdateLock} 
                          onChange={(e) => setIsUpdateLock(e.target.checked)} 
                        />
                        {isUpdateLock ? "Enable Update" : "Disable Update"}
                      </label>
                    </div>
                  )}
                  <div className="flex justify-center">
                    <button 
                      className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                      disabled={(isUpdateLock && mode==="update") || !rcaBookStatus}
                      onClick={handleSubmit}>
                        {mode === "add" ? "Add New" : "Update"}
                    </button>
                    <button 
                      className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                      onClick={() => navigate("/life-chronicles-home")}>
                        Cancel
                    </button>
                    {/* {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>} */}
                  </div>
                </div>
            </div>
          )}
        
        {/* Footer */}
        <footer className="bg-[#2a0f2f] border-t border-blue-800 text-blue-300 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm">
              © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
              <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
            </div>
          </div>
        </footer>
    </div>

  )
}

export default Task;